<div style="background-color:rgb(234,250,254);">
<span #tops></span>

<app-flight style="font-size: small;" [class]="pointerEvents?('pointerEventsNone'):''" (myOutput)="searchFlight()" ></app-flight>

<div class=" col-lg-12  " style="max-width: 100%; margin-top: -80px;position: relative;  width:100%;"  > 
<div class=" col-md-12 " >
 
<div  *ngIf="returnflight"   class="col-md-12 row">

  
  
  <!--##############filter#################=============================================================================-->
<!--###################################   filter ##################################################
     ###################################  filter ################################################## 
      ################################### filter ##################################################-->
      <div class="col-md-3 d-flex justify-content-end mt-4" >

        <!--  -->
<div *ngIf="returnflight"  class="col-md-11 scrollable-div sticky-tabs" style="height: 90vh; overflow-y: auto; font-size: 12px; background-color: white;" >
  <div [style]="multiSelectedTAB!=0?('display:none'):'display:block'">
  <div class="row">
    <span class="col-md-7" *ngIf="flightDetail"> {{flightDetail?.length}} of  {{this.returnflight[0]?.flights?.length}} Flights</span>
    <span class="col-md-5 d-flex justify-content-end  close" routerLink="/app/flight"   > <mat-icon>arrow_back</mat-icon></span>
  </div>
   
      <div class="col-md-12   bold" style="color:rgb(32,32,32); font-size: 18px;">
             
        <div class="col-md-12 ">
          <div class=" col-md-12"   style="min-width:100px; padding: 4px; margin-right: 8px;" >
            <mat-slide-toggle (click)="enableCheckBox()" [(ngModel)]="enableCheck">
              <button  mat-button disabled *ngIf="!enableCheck" ><mat-icon>share</mat-icon>Share</button>
              <button [matMenuTriggerFor]="showShareDialog" aria-label="Example icon-button with a menu" mat-raised-button *ngIf="enableCheck" ><mat-icon>share</mat-icon>Share</button>
            </mat-slide-toggle>
          
            <div *ngIf="rules" style="color: 017BFE;font-size: 14px;padding-top: 11px;padding-right: 10px;">
              <p-checkbox 
      [(ngModel)]="Incv" 
      [binary]="true" 
      inputId="binary" 
      label="Show Incv"/> 
<span style="padding-left: 5px; ">
      <p-checkbox 
      [(ngModel)]="net" 
      [binary]="true" 
      inputId="binary" 
      label="Show Net"/> 
    </span>
    </div>
            <mat-menu #showShareDialog="matMenu"  >
              <button mat-menu-item (click)="shareEmailPopup()">
                <mat-icon style="margin-right: 60px;"> insert_link</mat-icon>
                <span>Link</span>
              </button>
              <button mat-menu-item (click)="sendAllData()">
                <mat-icon style="margin-right: 60px;">done_all</mat-icon>
                <span>All</span>
              </button>
              <button mat-menu-item (click)="shareEmailPopup()">
                <mat-icon style="margin-right: 60px;">filter_list</mat-icon>
                <span>Filter</span>
              </button>
              <button mat-menu-item (click)="sendSelectedData()">
                <mat-icon style="margin-right: 60px;"> playlist_add_check</mat-icon>
                <span>Selected</span>
              </button>
             
            </mat-menu> 
          </div> 

          <!-- <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" (click)="sortByPrice()" > <button mat-raised-button><mat-icon>swap_vert</mat-icon>Price </button></div>  -->
<div class="row col-md-12" style="width: 100%;">
          <div class="col-md-3" style=" padding: 4px; font-size: 15px; " >₹{{minPrice}}</div>

          <div class="col-md-6 " style=" margin:0;  margin-top:-8px ; padding: 0;"  > 
             <mat-slider     
            style="margin: 0;padding: 0; "
            class="example-margin"
            [max]="maxPrice"
            [min]="minPrice"
            step="0"
            [discrete]="'true'"
            [showTickMarks]="'false'">
          <input matSliderThumb [(ngModel)]="value" (input)="combineFilters()" #slider>
        </mat-slider></div> 

          <div class="col-md-3" style="  font-size: 15px;" >₹{{maxPrice}}</div>
        </div>
        <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Sort </button>
          
          <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineFilter('airline')"><span class="hoverLine">Airlines</span></div>
          <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineFilter('departs')"><span class="hoverLine">Departs</span></div>
          <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineFilter('arrives')" ><span class="hoverLine">Arrives</span></div>
          <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineFilter('price')" ><span class="hoverLine">Price</span></div>
        </div>
          <div class="col-md-12 mt-2"style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Time </button>
            
            <!-- <mat-menu #showTimeDialog="matMenu"  > -->
              <mat-selection-list class="col-md-12" [(ngModel)]="filterTime"  (click)="combineFilters()" (click)="onMenuClick($event)" style=" background-color: white;">
                <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 10px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-list-option>
               
                <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 10px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-list-option>
                <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 10px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-list-option>
                <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 10px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-list-option>
                <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 10px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-list-option>
        
                </mat-selection-list>
            <!-- </mat-menu>   -->
          </div>
          <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "    aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Stops </button>
            <!-- <mat-menu #OpenDialog="matMenu" > -->
              <mat-selection-list [(ngModel)]="stop" (click)="combineFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1" style="font-size: 12px;">Non-stop</mat-list-option>
                <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2" style="font-size: 12px;">1 stop</mat-list-option>
                <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3" style="font-size: 12px;">2 stop</mat-list-option>
      
            </mat-selection-list>
            <!-- </mat-menu> -->
          </div> 
          <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Airlines </button>
            <!-- <mat-menu #OpenAirDialog="matMenu" > -->
              <mat-selection-list  [(ngModel)]="airlines" (click)="combineFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName" style="font-size: 12px;">{{fligthNameFilter(flightName)}}({{flightName}})</mat-list-option>
                
            </mat-selection-list>
            <!-- </mat-menu> -->
          </div> 
          <!-- <div class="col " style="min-width:100px; padding: 4px; margin-right: 8px;" ><button mat-raised-button><mat-icon>tune</mat-icon> Filters</button></div>  -->
          <!-- <div class=" " style="border: 1px solid #1876D1;border-radius: 4px;  "   aria-label="Example icon-button with a menu"><button mat-raised-button  > Fare Type</button> -->
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Fare Type</button>
     
              <mat-selection-list [(ngModel)]="fareType" (click)="combineFilters()" (click)="onMenuClick($event)">
                <mat-list-option color="primary" *ngFor="let item of fareTypeMenu" checkboxPosition="before" [value]="item" style="font-size: 12px;">{{item}}</mat-list-option>
              
            </mat-selection-list>
          
          </div> 
          
         
         
        </div>  
    </div>
   </div>


   <!-- +++++++++++++ return Filter +++++++++++++++++ -->
   <!-- +++++++++++++ return Filter +++++++++++++++++ -->
   <!-- +++++++++++++ return Filter +++++++++++++++++ -->

   <div [style]="multiSelectedTAB!=1?('display:none'):'display:block'">
    <div class="row">
      <span class="col-md-7" *ngIf="flightDetail"> {{returnFlightDetail?.length}} of  {{this.returnflight[1]?.flights?.length}} Flights</span>
      <span class="col-md-5 d-flex justify-content-end  close" routerLink="/app/flight"   > <mat-icon>arrow_back</mat-icon></span>
    </div>
     
        <div class="col-md-12   bold" style="color:rgb(32,32,32); font-size: 18px;">
               
          <div class="col-md-12 ">
            <div class=" col-md-12"   style="min-width:100px; padding: 4px; margin-right: 8px;" >
              <mat-slide-toggle (click)="enableCheckBox()" [(ngModel)]="enableCheck">
                <button  mat-button disabled *ngIf="!enableCheck" ><mat-icon>share</mat-icon>Share</button>
                <button [matMenuTriggerFor]="showShareDialog" aria-label="Example icon-button with a menu" mat-raised-button *ngIf="enableCheck" ><mat-icon>share</mat-icon>Share</button>
              </mat-slide-toggle>
            
              <div *ngIf="rules" style="color: 017BFE;font-size: 14px;padding-top: 11px;padding-right: 10px;">
                <p-checkbox 
        [(ngModel)]="Incv" 
        [binary]="true" 
        inputId="binary" 
        label="Show Incv"/> 
  <span style="padding-left: 5px; ">
        <p-checkbox 
        [(ngModel)]="net" 
        [binary]="true" 
        inputId="binary" 
        label="Show Net"/> 
      </span>
      </div>
              <mat-menu #showShareDialog="matMenu"  >
                <button mat-menu-item (click)="shareEmailPopup()">
                  <mat-icon style="margin-right: 60px;"> insert_link</mat-icon>
                  <span>Link</span>
                </button>
                <button mat-menu-item (click)="sendAllData()">
                  <mat-icon style="margin-right: 60px;">done_all</mat-icon>
                  <span>All</span>
                </button>
                <button mat-menu-item (click)="shareEmailPopup()">
                  <mat-icon style="margin-right: 60px;">filter_list</mat-icon>
                  <span>Filter</span>
                </button>
                <button mat-menu-item (click)="sendSelectedData()">
                  <mat-icon style="margin-right: 60px;"> playlist_add_check</mat-icon>
                  <span>Selected</span>
                </button>
               
              </mat-menu> 
            </div> 
  
            <!-- <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" (click)="sortByPrice()" > <button mat-raised-button><mat-icon>swap_vert</mat-icon>Price </button></div>  -->
  <div class="row col-md-12" style="width: 100%;">
            <div class="col-md-3" style=" padding: 4px; font-size: 15px; " >₹{{minPriceR}}</div>
  
            <div class="col-md-6 " style=" margin:0;  margin-top:-8px ; padding: 0;"  > 
               <mat-slider     
              style="margin: 0;padding: 0; "
              class="example-margin"
              [max]="maxPriceR"
              [min]="minPriceR"
              step="0"
              [discrete]="'true'"
              [showTickMarks]="'false'">
            <input matSliderThumb [(ngModel)]="valueR" (input)="combineRFilters()" #slider>
          </mat-slider></div> 
  
            <div class="col-md-3" style="  font-size: 15px;" >₹{{maxPriceR}}</div>
          </div>
       
          <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Sort </button>
          
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineRFilter('airline')"><span class="hoverLine">Airlines</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineRFilter('departs')"><span class="hoverLine">Departs</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineRFilter('arrives')" ><span class="hoverLine">Arrives</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineRFilter('price')" ><span class="hoverLine">Price</span></div>
          </div>
            <div class="col-md-12 mt-2"style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Time </button>
              
              <!-- <mat-menu #showTimeDialog="matMenu"  > -->
                <mat-selection-list class="col-md-12" [(ngModel)]="filterTimeR"  (click)="combineRFilters()" (click)="onMenuClick($event)" style=" background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 10px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-list-option>
                 
                  <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 10px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 10px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 10px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 10px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-list-option>
          
                  </mat-selection-list>
              <!-- </mat-menu>   -->
            </div>
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "    aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Stops </button>
              <!-- <mat-menu #OpenDialog="matMenu" > -->
                <mat-selection-list [(ngModel)]="stopR" (click)="combineRFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1" style="font-size: 12px;">Non-stop</mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2" style="font-size: 12px;">1 stop</mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3" style="font-size: 12px;">2 stop</mat-list-option>
        
              </mat-selection-list>
              <!-- </mat-menu> -->
            </div> 
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Airlines </button>
              <!-- <mat-menu #OpenAirDialog="matMenu" > -->
                <mat-selection-list  [(ngModel)]="airlinesR" (click)="combineRFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName" style="font-size: 12px;">{{fligthNameFilter(flightName)}}({{flightName}})</mat-list-option>
                  
              </mat-selection-list>
              <!-- </mat-menu> -->
            </div> 
            <!-- <div class="col " style="min-width:100px; padding: 4px; margin-right: 8px;" ><button mat-raised-button><mat-icon>tune</mat-icon> Filters</button></div>  -->
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Fare Type</button>
     
              <mat-selection-list [(ngModel)]="fareRType" (click)="combineRFilters()" (click)="onMenuClick($event)">
                <mat-list-option color="primary" *ngFor="let item of fareRTypeMenu" checkboxPosition="before" [value]="item" style="font-size: 12px;">{{item}}</mat-list-option>
              
            </mat-selection-list>
          
          </div> 
            
           
           
          </div>  
      </div>
     </div>
<!-- +++++++++++++ Third Filter +++++++++++++++++ -->
   <!-- +++++++++++++ Third Filter +++++++++++++++++ -->
   <!-- +++++++++++++ Third Filter +++++++++++++++++ -->

   <div [style]="multiSelectedTAB!=2?('display:none'):'display:block'">
    <div class="row">
      <span class="col-md-7" *ngIf="flightDetail"> {{thirdFlightDetail?.length}} of  {{this.returnflight[2]?.flights?.length}} Flights</span>
      <span class="col-md-5 d-flex justify-content-end  close" routerLink="/app/flight"   > <mat-icon>arrow_back</mat-icon></span>
    </div>
     
        <div class="col-md-12   bold" style="color:rgb(32,32,32); font-size: 18px;">
               
          <div class="col-md-12 ">
            <div class=" col-md-12"   style="min-width:100px; padding: 4px; margin-right: 8px;" >
              <mat-slide-toggle (click)="enableCheckBox()" [(ngModel)]="enableCheck">
                <button  mat-button disabled *ngIf="!enableCheck" ><mat-icon>share</mat-icon>Share</button>
                <button [matMenuTriggerFor]="showShareDialog" aria-label="Example icon-button with a menu" mat-raised-button *ngIf="enableCheck" ><mat-icon>share</mat-icon>Share</button>
              </mat-slide-toggle>
              <div *ngIf="rules" style="color: 017BFE;font-size: 14px;padding-top: 11px;padding-right: 10px;">
                <p-checkbox 
        [(ngModel)]="Incv" 
        [binary]="true" 
        inputId="binary" 
        label="Show Incv"/> 
  <span style="padding-left: 5px; ">
        <p-checkbox 
        [(ngModel)]="net" 
        [binary]="true" 
        inputId="binary" 
        label="Show Net"/> 
      </span>
      </div>
            
              <mat-menu #showShareDialog="matMenu"  >
                <button mat-menu-item (click)="shareEmailPopup()">
                  <mat-icon style="margin-right: 60px;"> insert_link</mat-icon>
                  <span>Link</span>
                </button>
                <button mat-menu-item (click)="sendAllData()">
                  <mat-icon style="margin-right: 60px;">done_all</mat-icon>
                  <span>All</span>
                </button>
                <button mat-menu-item (click)="shareEmailPopup()">
                  <mat-icon style="margin-right: 60px;">filter_list</mat-icon>
                  <span>Filter</span>
                </button>
                <button mat-menu-item (click)="sendSelectedData()">
                  <mat-icon style="margin-right: 60px;"> playlist_add_check</mat-icon>
                  <span>Selected</span>
                </button>
               
              </mat-menu> 
            </div> 
  
            <!-- <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" (click)="sortByPrice()" > <button mat-raised-button><mat-icon>swap_vert</mat-icon>Price </button></div>  -->
  <div class="row col-md-12" style="width: 100%;">
            <div class="col-md-3" style=" padding: 4px; font-size: 15px; " >₹{{minPriceT}}</div>
  
            <div class="col-md-6 " style=" margin:0;  margin-top:-8px ; padding: 0;"  > 
               <mat-slider     
              style="margin: 0;padding: 0; "
              class="example-margin"
              [max]="maxPriceT"
              [min]="minPriceT"
              step="0"
              [discrete]="'true'"
              [showTickMarks]="'false'">
            <input matSliderThumb [(ngModel)]="valueT" (input)="combineTFilters()" #slider>
          </mat-slider></div> 
  
            <div class="col-md-3" style="  font-size: 15px;" >₹{{maxPriceT}}</div>
          </div>
       
          
          <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Sort </button>
          
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineTFilter('airline')"><span class="hoverLine">Airlines</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineTFilter('departs')"><span class="hoverLine">Departs</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineTFilter('arrives')" ><span class="hoverLine">Arrives</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineTFilter('price')" ><span class="hoverLine">Price</span></div>
          </div>
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Time </button>
              
              <!-- <mat-menu #showTimeDialog="matMenu"  > -->
                <mat-selection-list class="col-md-12" [(ngModel)]="filterTimeT"  (click)="combineTFilters()" (click)="onMenuClick($event)" style=" background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 10px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-list-option>
                 
                  <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 10px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 10px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 10px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 10px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-list-option>
          
                  </mat-selection-list>
              <!-- </mat-menu>   -->
            </div>
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "    aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Stops </button>
              <!-- <mat-menu #OpenDialog="matMenu" > -->
                <mat-selection-list [(ngModel)]="stopT" (click)="combineTFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1" style="font-size: 12px;">Non-stop</mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2" style="font-size: 12px;">1 stop</mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3" style="font-size: 12px;">2 stop</mat-list-option>
        
              </mat-selection-list>
              <!-- </mat-menu> -->
            </div> 
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Airlines </button>
              <!-- <mat-menu #OpenAirDialog="matMenu" > -->
                <mat-selection-list  [(ngModel)]="airlinesT" (click)="combineTFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName" style="font-size: 12px;">{{fligthNameFilter(flightName)}}({{flightName}})</mat-list-option>
                  
              </mat-selection-list>
              <!-- </mat-menu> -->
            </div> 
            <!-- <div class="col " style="min-width:100px; padding: 4px; margin-right: 8px;" ><button mat-raised-button><mat-icon>tune</mat-icon> Filters</button></div>  -->
  
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Fare Type</button>
     
              <mat-selection-list [(ngModel)]="fareTType" (click)="combineTFilters()" (click)="onMenuClick($event)">
                <mat-list-option color="primary" *ngFor="let item of fareTTypeMenu" checkboxPosition="before" [value]="item" style="font-size: 12px;">{{item}}</mat-list-option>
              
            </mat-selection-list>
          
          </div> 
           
           
          </div>  
      </div>
     </div>

     <!-- +++++++++++++ Fourth Filter +++++++++++++++++ -->
   <!-- +++++++++++++ Fourth Filter +++++++++++++++++ -->
   <!-- +++++++++++++ Fourth Filter +++++++++++++++++ -->

   <div [style]="multiSelectedTAB!=3?('display:none'):'display:block'">
    <div class="row">
      <span class="col-md-7" *ngIf="flightDetail"> {{fourthFlightDetail?.length}} of  {{this.returnflight[3]?.flights?.length}} Flights</span>
      <span class="col-md-5 d-flex justify-content-end  close" routerLink="/app/flight"   > <mat-icon>arrow_back</mat-icon></span>
    </div>
     
        <div class="col-md-12   bold" style="color:rgb(32,32,32); font-size: 18px;">
               
          <div class="col-md-12 ">
            <div class=" col-md-12"   style="min-width:100px; padding: 4px; margin-right: 8px;" >
              <mat-slide-toggle (click)="enableCheckBox()" [(ngModel)]="enableCheck">
                <button  mat-button disabled *ngIf="!enableCheck" ><mat-icon>share</mat-icon>Share</button>
                <button [matMenuTriggerFor]="showShareDialog" aria-label="Example icon-button with a menu" mat-raised-button *ngIf="enableCheck" ><mat-icon>share</mat-icon>Share</button>
              </mat-slide-toggle>
            
              <div *ngIf="rules" style="color: 017BFE;font-size: 14px;padding-top: 11px;padding-right: 10px;">
                <p-checkbox 
        [(ngModel)]="Incv" 
        [binary]="true" 
        inputId="binary" 
        label="Show Incv"/> 
  <span style="padding-left: 5px; ">
        <p-checkbox 
        [(ngModel)]="net" 
        [binary]="true" 
        inputId="binary" 
        label="Show Net"/> 
      </span>
      </div>
              <mat-menu #showShareDialog="matMenu"  >
                <button mat-menu-item (click)="shareEmailPopup()">
                  <mat-icon style="margin-right: 60px;"> insert_link</mat-icon>
                  <span>Link</span>
                </button>
                <button mat-menu-item (click)="sendAllData()">
                  <mat-icon style="margin-right: 60px;">done_all</mat-icon>
                  <span>All</span>
                </button>
                <button mat-menu-item (click)="shareEmailPopup()">
                  <mat-icon style="margin-right: 60px;">filter_list</mat-icon>
                  <span>Filter</span>
                </button>
                <button mat-menu-item (click)="sendSelectedData()">
                  <mat-icon style="margin-right: 60px;"> playlist_add_check</mat-icon>
                  <span>Selected</span>
                </button>
               
              </mat-menu> 
            </div> 
  
            <!-- <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" (click)="sortByPrice()" > <button mat-raised-button><mat-icon>swap_vert</mat-icon>Price </button></div>  -->
  <div class="row col-md-12" style="width: 100%;">
            <div class="col-md-3" style=" padding: 4px; font-size: 15px; " >₹{{minPriceF}}</div>
  
            <div class="col-md-6 " style=" margin:0;  margin-top:-8px ; padding: 0;"  > 
               <mat-slider     
              style="margin: 0;padding: 0; "
              class="example-margin"
              [max]="maxPriceF"
              [min]="minPriceF"
              step="0"
              [discrete]="'true'"
              [showTickMarks]="'false'">
            <input matSliderThumb [(ngModel)]="valueF" (input)="combineFFilters()" #slider>
          </mat-slider></div> 
  
            <div class="col-md-3" style="  font-size: 15px;" >₹{{maxPriceF}}</div>
          </div>
          <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Sort </button>
          
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineFFilter('airline')"><span class="hoverLine">Airlines</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;" (click)="combineFFilter('departs')"><span class="hoverLine">Departs</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineFFilter('arrives')" ><span class="hoverLine">Arrives</span></div>
            <div class=" mt-2 mb-2" style="color:#007bff ;font-size: medium;padding-left: 8px;cursor: pointer;"(click)="combineFFilter('price')" ><span class="hoverLine">Price</span></div>
          </div>
            <div class="col-md-12 mt-2"style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Time </button>
              
              <!-- <mat-menu #showTimeDialog="matMenu"  > -->
                <mat-selection-list class="col-md-12" [(ngModel)]="filterTimeF"  (click)="combineFFilters()" (click)="onMenuClick($event)" style=" background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 10px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-list-option>
                 
                  <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 10px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 10px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 10px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 10px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-list-option>
          
                  </mat-selection-list>
              <!-- </mat-menu>   -->
            </div>
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "    aria-label="Example icon-button with a menu"><button  style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;" mat-flat-button>Stops </button>
              <!-- <mat-menu #OpenDialog="matMenu" > -->
                <mat-selection-list [(ngModel)]="stopF" (click)="combineFFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1" style="font-size: 12px;">Non-stop</mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2" style="font-size: 12px;">1 stop</mat-list-option>
                  <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3" style="font-size: 12px;">2 stop</mat-list-option>
        
              </mat-selection-list>
              <!-- </mat-menu> -->
            </div> 
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Airlines </button>
              <!-- <mat-menu #OpenAirDialog="matMenu" > -->
                <mat-selection-list  [(ngModel)]="airlinesF" (click)="combineFFilters()" (click)="onMenuClick($event)" style="width: 100%; background-color: white;">
                  <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName" style="font-size: 12px;">{{fligthNameFilter(flightName)}}({{flightName}})</mat-list-option>
                  
              </mat-selection-list>
              <!-- </mat-menu> -->
            </div> 
            <!-- <div class="col " style="min-width:100px; padding: 4px; margin-right: 8px;" ><button mat-raised-button><mat-icon>tune</mat-icon> Filters</button></div>  -->
  
            <div class="col-md-12 mt-2" style="border: 1px solid #1876D1;border-radius: 4px;  "  aria-label="Example icon-button with a menu" ><button  style="width: 100%;background-color: #1876D1;;font-weight: 700; color: white;" mat-flat-button>Fare Type</button>
     
              <mat-selection-list [(ngModel)]="fareFType" (click)="combineFFilters()" (click)="onMenuClick($event)">
                <mat-list-option color="primary" *ngFor="let item of fareFTypeMenu" checkboxPosition="before" [value]="item" style="font-size: 12px;">{{item}}</mat-list-option>
              
            </mat-selection-list>
          
          </div> 
           
           
          </div>  
      </div>
     </div>
     <!-- ############## -->
          <!-- ############## -->
               <!-- ############## -->


</div>
</div>

      <mat-expansion-panel *ngIf="false"  hideToggle disabled style=" margin-left: 20px; margin-right: 20px; ; min-height: 50px;">
   
        <mat-expansion-panel-header style="background-color: transparent;">
          <mat-panel-title style="background-color: transparent;">
            <div class="col-md-12 row  bold" style="color:rgb(32,32,32); font-size: 18px;">
             
                <div class="col-md-12 d-flex justify-content-end">
                  <div class=" "   style="min-width:100px; padding: 4px; margin-right: 8px;" >
                    <mat-slide-toggle (click)="enableCheckBox()" [(ngModel)]="enableCheck">
                      <button  mat-button disabled *ngIf="!enableCheck" ><mat-icon>share</mat-icon>Share</button>
                      <button [matMenuTriggerFor]="showShareDialog" aria-label="Example icon-button with a menu" mat-raised-button *ngIf="enableCheck" ><mat-icon>share</mat-icon>Share</button>
                    </mat-slide-toggle>
                  
                  
                    <mat-menu #showShareDialog="matMenu"  >
                      <button mat-menu-item (click)="shareEmailPopup()">
                        <mat-icon style="margin-right: 60px;"> insert_link</mat-icon>
                        <span>Link</span>
                      </button>
                      <button mat-menu-item (click)="sendAllData()">
                        <mat-icon style="margin-right: 60px;">done_all</mat-icon>
                        <span>All</span>
                      </button>
                      <button mat-menu-item (click)="shareEmailPopup()">
                        <mat-icon style="margin-right: 60px;">filter_list</mat-icon>
                        <span>Filter</span>
                      </button>
                      <button mat-menu-item (click)="sendSelectedData()">
                        <mat-icon style="margin-right: 60px;"> playlist_add_check</mat-icon>
                        <span>Selected</span>
                      </button>
                     
                    </mat-menu> 
                  </div> 

                  <!-- <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" (click)="sortByPrice()" > <button mat-raised-button><mat-icon>swap_vert</mat-icon>Price </button></div>  -->

                  <div class="d-flex justify-content-end" style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{minPrice}}</div>

                  <div class=" " style="min-width:100px;  margin:0;  margin-top:-4px ; padding: 0;"  > 
                     <mat-slider     
                    style="margin: 0;padding: 0; "
                    class="example-margin"
                    [max]="maxPrice"
                    [min]="minPrice"
                    step="0"
                    [discrete]="'false'"
                    [showTickMarks]="'false'">
                  <input matSliderThumb [(ngModel)]="value" (input)="combineFilters()" #slider>
                </mat-slider></div> 

                  <div style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{maxPrice}}</div>
                  <div class=" "style="padding: 4px; margin-right: 8px;" [matMenuTriggerFor]="showTimeDialog" aria-label="Example icon-button with a menu"><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Time </button>
                    
                    <mat-menu #showTimeDialog="matMenu"  >
                      <mat-selection-list [(ngModel)]="filterTime" (click)="combineFilters()" (click)="onMenuClick($event)">
                        <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 12px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-list-option>
                       
                        <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 12px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 12px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 12px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 12px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-list-option>
                
                        </mat-selection-list>
                    </mat-menu> </div> 
                  <div class=" "  style="padding: 4px; margin-right: 8px; " [matMenuTriggerFor]="OpenDialog" aria-label="Example icon-button with a menu"><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Stops </button>
                    <mat-menu #OpenDialog="matMenu" >
                      <mat-selection-list [(ngModel)]="stop" (click)="combineFilters()" (click)="onMenuClick($event)">
                        <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1" style="font-size: 12px;">Non-stop</mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2" style="font-size: 12px;">1 stop</mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3" style="font-size: 12px;">2 stop</mat-list-option>
              
                    </mat-selection-list>
                    </mat-menu>
                  </div> 
                  <div class=" " style="padding: 4px; margin-right: 8px;" [matMenuTriggerFor]="OpenAirDialog" aria-label="Example icon-button with a menu" ><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Airlines </button>
                    <mat-menu #OpenAirDialog="matMenu" >
                      <mat-selection-list  [(ngModel)]="airlines" (click)="combineFilters()" (click)="onMenuClick($event)">
                        <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName" style="font-size: 12px;">{{fligthNameFilter(flightName)}}({{flightName}})</mat-list-option>
                        
                    </mat-selection-list>
                    </mat-menu>
                  </div> 
                  <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" ><button mat-raised-button><mat-icon>tune</mat-icon> Filters</button></div> 
    
                  
                 
                 
                </div>  
            </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
       
      </mat-expansion-panel>
<div class="col-md-9 " >
      <div  class="col-md-12 sticky-tabs" style="  min-height: 50px;">
        <div class="col-md-12 d-flex justify-content-center" >
        <span class="flight-info-item"   *ngFor="let  item  of returnflight;let i=index" (click)="ontabClick(i)" [ngClass]="{'tabActive' :multiSelectedTAB===i}"  style="height: 80px; width: 100%;background-color:white ; border-radius: 4px; cursor: pointer;">
           <div *ngIf="i===0">
            <strong>{{cityFilter(item.fromAirport) +'-'+ cityFilter(item.toAirport)}}</strong>
            <br>
                <small>{{ departureFlight?(dateFormate(departureFlight?.schDepartureTime)):'-'}}</small>
                <br>

                <small>{{ departureFlight?.schDepartureTime | date:'HH:mm'}} -</small>
                <small>{{departureFlight?.schArrivalTime | date:'HH:mm'}}</small>
               
              
           </div>
           <div *ngIf="i===1">
            <strong>{{cityFilter(item.fromAirport) +'-'+ cityFilter(item.toAirport)}}</strong>
            <br>
                <small>{{ returnFlight?.schDepartureTime?(dateFormate(returnFlight?.schDepartureTime)):"-"}}</small>
                <br>

                <small>{{ returnFlight?.schDepartureTime | date:'HH:mm'}} -</small>
                <small>{{returnFlight?.schArrivalTime | date:'HH:mm'}}</small>
               
           </div>
           <div *ngIf="i===2">
            <strong>{{cityFilter(item.fromAirport) +'-'+ cityFilter(item.toAirport)}}</strong>
            <br>
                <small>{{ thirdFlight?(dateFormate(thirdFlight?.schDepartureTime)):'-'}}</small>
                <br>

                <small>{{ thirdFlight?.schDepartureTime |date:'HH:mm'}} -</small>
                <small>{{thirdFlight?.schArrivalTime | date:'HH:mm'}}</small>
               
           </div>
           <div *ngIf="i===3">
            <strong>{{cityFilter(item.fromAirport) +'-'+ cityFilter(item.toAirport)}}</strong>
            <br>
                <small>{{ fourthFlight?(dateFormate(fourthFlight?.schDepartureTime)):'-'}}</small>
                <br>

                <small>{{ fourthFlight?.schDepartureTime | date:'HH:mm'}} -</small>
                <small>{{fourthFlight?.schArrivalTime | date:'HH:mm'}}</small>
               
           </div>
        </span>
        </div>
       </div>






    <!--##############MULTI Flight#################=============================================================================-->
 <!--##############MULTI Flight#################=============================================================================-->
<!--###################################   MULTI Flight ##################################################
     ###################################  MULTI Flight  ################################################## 
      ################################### MULTI Flight ##################################################-->
<span  class="col-md-12 "  >
     <!-------------################## 1stTAb   ###############-->
    <!-------------################## 1stTAb   ###############-->
  <!-------------################## 1stTAb   ###############-->
    <span class="col-md-12" [style]="multiSelectedTAB!=0?('display:none'):'display:block'" >
   
    <div >
      <mat-accordion class="example-headers-align" multi style="margin-top: 10px;">
       
    <mat-expansion-panel  [ngClass]="{'active' :activeDeparture(item)}" *ngFor="let item of flightDetail" [expanded]="item.selected" disabled hideToggle  style="margin-top: 5px; margin-left: 10px;  ">
      <mat-expansion-panel-header style="min-height:80px;">
        <mat-panel-title style="color: rgb(33,33,33);" class="row">
          <div class="col-md-1">
            <img  [src]="flightlogoFilter(item?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">
  
          
        </div>
          
          <div class="col-md-2" style="font-size: 14px;">
            {{fligthNameFilter(item?.flightDetailsList[0]?.carrierName)}}
            <span style="font-size: 13px; color: grey; min-width: 10%;white-space:nowrap;">{{item?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flightDetailsList[0]?.flightNumber}}
           
                <br>  <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                <span class="bold" style="padding-left: 6px;" *ngIf="distancePlus(item?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flightDetailsList)}}</span>
  
            </span>
  
          </div>
          
          
         
          <div class="col-md-8 row pt-3"  style="white-space: nowrap;">
                
            <div class="col-md-3 bold" >{{ item?.schDepartureTime | date:'HH:mm'}}</div>
            <!-- &nbsp;&nbsp; -->
            <div class="col-md-3">
            <span >{{converter(item?.travelDuration)}} </span> 
            <div *ngIf="item?.hopCount===1" style="border-bottom:2px solid rgb(10, 210, 60) ;width: 30%;" ></div>
            <div *ngIf="item?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;width: 30%;"></div>
            <div *ngIf="item?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;width: 30%;"></div>
  
              <span class="d-flex justify-content-start" *ngIf="item?.hopCount===1" (click)="popoveritemContent.toggle($event)" style="font-size: 13px; color: grey;align-items: start; ">{{item?.hopCount===1?('non-stop'):''}}</span>
              <span class="d-flex justify-content-start" *ngIf="item?.hopCount!=1" (click)="popoveritemContent.toggle($event)" style="font-size: 13px; color: grey; align-items: start;">&nbsp;&nbsp;{{item?.hopCount?(item?.hopCount-1+'-'+'stop'):''}}</span>
              <p-overlayPanel  #popoveritemContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of item.flightDetailsList">
          
          <div class="mb-3 mt-1">
            <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
        </div><br>
      <div class="col-md-2">
        <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
    
      
    <br>
    {{fligthNameFilter(element?.carrierName)}}<br>
        <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
          <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
          <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
         <!--<span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
        -->
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
          <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
    
        </span>
    </div>
    
    <div class="col-md-2">
        {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
        <br>
        <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
    </div>
    <div class="col-md-2">
        <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
        <br>
        <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
       
    </div>
    <div class="col-md-2">
      {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
        <br>
        <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
    </div>
    <div class="col-md-2">
            
        <!-- <span style="font-size: 12px;">Check-in baggage</span>
        <br>
        <span style="font-size: 12px;">  Cabin baggage</span> -->
    </div>
    <div class="col-md-2">
        <!-- <span style="font-size: 13px;">20kg/ Adult</span>
         <br>
         <span style="font-size: 13px;">7kg/ Adult</span> -->
     </div>
        </div>
      </p-overlayPanel>
            </div>
            <!-- &nbsp;&nbsp; -->
            <div class="col-md-3 bold" >{{item?.schArrivalTime | date:'HH:mm'}}
              <small style="color: red;font-size: 12px;" ngbPopover="{{item?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
              triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.schDepartureTime,item?.schArrivalTime)}}</small>
  
            </div>
           
  <div class="col-md-3  d-flex justify-content-center">



    <div  class="col-md-12 row " [style]="item?.fare[0]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item?.fare[0]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item.fare[0]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
      <div *ngIf="item.fare[0]" class="col-md-12 row">
        <div class="col-md-12 " (click)="setStep(0)" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;"> 
          <span *ngIf="!enableCheck"  (click)="onClickFare(item.fare[0], item.fare,item)">
          <mat-icon class="mat-primary" *ngIf="item.fare[0].selected==='true'">radio_button_checked</mat-icon>
          <mat-icon style="color: #757575;" *ngIf="item.fare[0].selected===''">radio_button_unchecked</mat-icon>
          
          <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
          triggers="mouseenter:mouseleave">
          ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
          <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
            (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
            (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
            (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
            item?.fare[0]?.commercialData?.finalAmount}} -->
          </span> 

        </span>    
        <span *ngIf="enableCheck" >
          <!-- <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectShareData($event,item,item?.fare[0])"></mat-checkbox> -->

          <!-- <mat-icon *ngIf="enableCheck" style=" color: #757575;">check_box_outline_blank</mat-icon>
          <mat-icon *ngIf="false"  class="mat-primary">check_box</mat-icon> -->
          <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
          triggers="mouseenter:mouseleave">
          ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
          <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
            (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
            (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
            (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
            item?.fare[0]?.commercialData?.finalAmount}} -->
          </span> 

        </span>        
          <!-- <mat-radio-group (click)="setStep(0)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="item.fare[0].selected" >
            <mat-radio-button  color="primary" class="example-radio-button "  (click)="onClickFare(item.fare[0], item.fare,item)"  value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;font-size: 18px;">₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax}}</span></mat-radio-button>
          </mat-radio-group> -->
          
        </div>
         
      </div>
       <!-- <div class="col-md-12 row" >
            <span class="col-md-1 "></span>
            <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 10px;">{{item?.fare[0]?.refundable===true?('Refundable'):''}}</span>
            <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 10px;"> {{item?.fare[0]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
            <span class="col-md-1 "></span>
            <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
            <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
          </div> -->
      <div *ngIf="item.fare[0]" class="col-md-12 bold row"style="padding-left: 23px;padding-top: 4px;">
        <!-- <mat-checkbox (click)="setStep(0)" color="primary" class="example-ripple-checkbox">{{item.fare[0].fareType}}</mat-checkbox>                        -->

        <span (click)="setStep(0)" color="primary" >
          <!-- {{item.fare[0]?.corporateFare?("Corporate"):item.fare[0].fareType}} -->
          {{item.fare[0]?.fareTypeDisplay}}

        </span>                       
      </div> 

        <!-- <div class="col md-7"  ><span style=" color:rgb(1,123,254);cursor: pointer; font-weight: 600;" [ngbPopover]="popoverContent" container="body"
          triggers="mouseenter:mouseleave">&#8377;{{item.fare[0].baseFare+item.fare[0]?.finalTax}} </span></div> -->
</div>

<ng-template #popoverContent class="col-md-12"  >
  <div class="  col-md-12 ">

  <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                style="overflow-y:scroll;max-height: 95%; width: 100%;">
                <thead class="thead-light" style="white-space:nowrap;">
                  <tr>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                    <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>



                  </tr>
                </thead>
                <tbody >
                  <tr  style="height: 25px; ">
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].baseFare}}</td>
                  
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].finalTax}}</td>
                    <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                      {{
                        (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                      }}</td>
                  
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{
                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                        (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                        (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                      
                    }}</td> -->

                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                  
                  
                  </tr>
                </tbody>
              </table>
              <div class=" mt-1" *ngIf="messageData.adultCount">
                <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                 <span> {{passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}

                            <!-- remove in hover only -->

                  <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>) -->
                </span>
                
             
            </div>
            <div class=" mt-1" *ngIf="messageData.childCount">
              <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
              <span> {{passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}

                            <!-- remove in hover only -->

                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                  {{ entry.key }}{{ entry.value | json }},
                 </span>) -->
              </span>
              
           
          </div>
          <div class=" mt-1" *ngIf="messageData.infantCount">
            <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
            <span> {{passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
                            <!-- remove in hover only -->


              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                {{ entry.key }}{{ entry.value | json }},
               </span>) -->
            </span>
            
         
        </div>

  </div>
  </ng-template>





    
  </div>
            
            </div>
            
        <div  *ngIf="!enableCheck" class="col-md-1" style="width: 40px;" class="d-flex justify-content-end">
                  
          <button *ngIf="item?.dropDown===false"  mat-icon-button  (click)="selectFlight(item);onClickDepartureDown(item)" >
            <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
          </button>
          <button *ngIf="item?.dropDown===true" mat-icon-button  (click)="onClickDepartureUp(item)">
            <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
          </button>
          
        </div>
       
          </mat-panel-title>
        
        
          
      </mat-expansion-panel-header>
      <div *ngIf="item?.dropDown===true" class="col-md-12 row">
  
  
        <table class="styled-tables " style="white-space:nowrap; ">
          <thead>
            <tr  >
              <!-- Dynamic headers based on tableHeaders array -->
              <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
              <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
              <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
              <th style="padding: 8px;  text-align: center;text-align: left;"></th>
  
            </tr>
          </thead>
          <tbody class="box-shadow">
            <!-- Iterate through dynamic data rows -->
            <tr  *ngFor="let fare of item?.fare;" >
              <!-- Display structured data -->
              
              <td class=" " style="padding: 8px;" [style]="fare.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
                <span class="col-md-12 row" >
                  <span class="col-md-12">
                    <mat-checkbox color="primary"  *ngIf="enableCheck"  (change)="selectShareData($event,item,fare)"></mat-checkbox>
                    <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }} -->
                    {{fare?.fareTypeDisplay }}

                    <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(true,false,false,false);onClickITINERARYTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    
                    <br><small *ngIf="parentType==='Staff'" style="color: rgb(194, 129, 8);">{{fare?.source}}</small>  

                  </span>

            </span>
              </td>
              <td class="" style="padding: 8px;">
              {{fare?.refundable===true?('Refundable'):''}}
               {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}
                <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(true,false,false,false);onClickCancellationTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    

              </td>
              <!-- <td class="name-type" style="padding: 8px;">
               
              </td> -->
              <td class="" style="padding: 8px;">
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
              
              </td>
              <td class="" style="padding: 8px;">{{fareOMapping(fare,item,item?.fare)[0]?.seatsAvailability}}</td>
              <td class="" style="padding: 8px;">
                <!-- change fun fareOMapping -->
                {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}
  
                 <!-- {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG'):"N/A"}} -->
              </td>
              <td class="" style="padding: 8px;">{{'7KG'}}</td>
              <td  style="padding: 8px;">
             
               <span (click)="onClickFare(fare, item.fare,item)">
                <mat-icon class="mat-primary" *ngIf="fare.selected==='true'">radio_button_checked</mat-icon>
                <mat-icon style="color: #757575;" *ngIf="fare.selected===''">radio_button_unchecked</mat-icon>
                <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                triggers="mouseenter:mouseleave">
                ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}} <br>
                <span *ngIf="Incv" style="color: grey;font-size: 12px;"> Incv ₹{{fare?.incentiveAmt}}&nbsp;</span>
                <span *ngIf="net" style="color: grey;font-size: 12px;">  Net ₹{{fare?.netFare}}&nbsp;</span> 
  
               

                <!-- ₹{{(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  fare?.commercialData?.finalAmount}} -->
                
               </span>
  
                
              </span> 
              <ng-template #popoverContent class="col-md-12"  >
                <div class="  col-md-12 ">
  
                <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                              style="overflow-y:scroll;max-height: 95%; width: 100%;">
                              <thead class="thead-light" style="white-space:nowrap;">
                                <tr>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                  <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
  
  
  
                                </tr>
                              </thead>
                              <tbody >
                                <tr  style="height: 25px; ">
                                  <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                    (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                    }}</td>
                                
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                      (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                    }}</td> -->
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare?.baseFare}}</td>
                              
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare?.finalTax}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                
                                
                                
                                </tr>
                              </tbody>
                            </table>
                            <div class=" mt-1" *ngIf="messageData.adultCount">
                              <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                               <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                  {{ entry.key }}{{ entry.value | json }},
                                 </span>) -->
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.childCount">
                            <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                            <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                        <div class=" mt-1" *ngIf="messageData.infantCount">
                          <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                          <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
  
                </div>
                </ng-template> 
              </td>
  
            </tr>
          </tbody>
        </table>
  
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  </div>
  </span>
 <!-------------################## 2ndTAb   ###############-->
    <!-------------################## 2ndTAb   ###############-->
  <!-------------################## 2ndTAb   ###############-->


  <span class="col-md-12"  [style]="multiSelectedTAB!=1?('display:none'):'display:block'">
    <!-- style="height: 38vh; overflow-y: auto;" -->
    <div >
      <mat-accordion class="example-headers-align" multi style="margin-top: 10px;">
  
    <mat-expansion-panel  [ngClass]="{'active' :activeReturn(item)}"  *ngFor="let item of returnFlightDetail" [expanded]="item.selected" disabled hideToggle  style="margin-top: 5px; margin-left: 10px;margin-right: 10px; ">
      <mat-expansion-panel-header  style="min-height:80px;">
        <mat-panel-title style="color: rgb(33,33,33);" class="row">
          <div class="col-md-1">
            <img  [src]="flightlogoFilter(item?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">
  
                </div>
          <div style="font-size: 14px; " class="col-md-2">
          {{fligthNameFilter(item?.flightDetailsList[0]?.carrierName)}}
          <span style="font-size: 13px; color: grey; white-space:nowrap;">{{item?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flightDetailsList[0]?.flightNumber}}
            <br>
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" style="padding-left: 6px;" *ngIf="distancePlus(item?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flightDetailsList)}}</span>
  
          </span>
  
          </div>
         
          <div class="col-md-8 row mt-3"  style="white-space: nowrap;">
                
            <div class="col-md-3 bold" >{{ item?.schDepartureTime | date:'HH:mm'}}</div>
            <div class="col-md-3">
              
            <span >{{converter(item?.travelDuration)}} </span> 
            <div *ngIf="item?.hopCount===1" style="border-bottom:2px solid rgb(10, 210, 60) ;width: 30%;" ></div>
            <div *ngIf="item?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;width: 30%;"></div>
            <div *ngIf="item?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;width: 30%;"></div>
  
              <span class="d-flex justify-content-start" (click)="popoveritemRContent.toggle($event)" *ngIf="item?.hopCount===1" style="font-size: 13px; color: grey;align-items: start; ">{{item?.hopCount===1?('non-stop'):''}}</span>
              <span class="d-flex justify-content-start" (click)="popoveritemRContent.toggle($event)" *ngIf="item?.hopCount!=1" style="font-size: 13px; color: grey; align-items: start;">&nbsp;&nbsp;{{item?.hopCount?(item?.hopCount-1+'-'+'stop'):''}}</span>
              <p-overlayPanel  #popoveritemRContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of item.flightDetailsList">
          
          <div class="mb-3 mt-1">
            <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
        </div><br>
      <div class="col-md-2">
        <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
    
      
    <br>
    {{fligthNameFilter(element?.carrierName)}}<br>
        <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
          <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
          <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
         <!--<span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
        -->
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
          <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
    
        </span>
    </div>
    
    <div class="col-md-2">
        {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
        <br>
        <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
    </div>
    <div class="col-md-2">
        <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
        <br>
        <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
       
    </div>
    <div class="col-md-2">
      {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
        <br>
        <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
    </div>
    <div class="col-md-2">
            
        <!-- <span style="font-size: 12px;">Check-in baggage</span>
        <br>
        <span style="font-size: 12px;">  Cabin baggage</span> -->
    </div>
    <div class="col-md-2">
        <!-- <span style="font-size: 13px;">20kg/ Adult</span>
         <br>
         <span style="font-size: 13px;">7kg/ Adult</span> -->
     </div>
        </div>
      </p-overlayPanel>
            </div>
            <div class="col-md-3 bold" >{{item?.schArrivalTime | date:'HH:mm'}}
              <small style="color: red;font-size: 12px;" ngbPopover="{{item?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
                    triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.schDepartureTime,item?.schArrivalTime)}}</small>
            </div>
            <div class="col-md-3  d-flex justify-content-center">



              <div  class="col-md-12 row " [style]="item?.fare[0]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item?.fare[0]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item.fare[0]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
                <div *ngIf="item.fare[0]" class="col-md-12 row">
                  <div class="col-md-12 " (click)="setStep(0)" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;"> 
                    <span *ngIf="!enableCheck"  (click)="onClickRFare(item.fare[0], item.fare,item)">
                    <mat-icon class="mat-primary" *ngIf="item.fare[0].selected==='true'">radio_button_checked</mat-icon>
                    <mat-icon style="color: #757575;" *ngIf="item.fare[0].selected===''">radio_button_unchecked</mat-icon>
                    
                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">
                    ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
                    <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      item?.fare[0]?.commercialData?.finalAmount}} -->
                    </span> 
          
                  </span>    
                  <span *ngIf="enableCheck" >
                    <!-- <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectShareData($event,item,item?.fare[0])"></mat-checkbox> -->
          
                    <!-- <mat-icon *ngIf="enableCheck" style=" color: #757575;">check_box_outline_blank</mat-icon>
                    <mat-icon *ngIf="false"  class="mat-primary">check_box</mat-icon> -->
                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">
                    ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
                    <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      item?.fare[0]?.commercialData?.finalAmount}} -->
                    </span> 
          
                  </span>        
                    <!-- <mat-radio-group (click)="setStep(0)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="item.fare[0].selected" >
                      <mat-radio-button  color="primary" class="example-radio-button "  (click)="onClickFare(item.fare[0], item.fare,item)"  value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;font-size: 18px;">₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax}}</span></mat-radio-button>
                    </mat-radio-group> -->
                    
                  </div>
                   
                </div>
                 <!-- <div class="col-md-12 row" >
                      <span class="col-md-1 "></span>
                      <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 10px;">{{item?.fare[0]?.refundable===true?('Refundable'):''}}</span>
                      <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 10px;"> {{item?.fare[0]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
                      <span class="col-md-1 "></span>
                      <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                      <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
                    </div> -->
                <div *ngIf="item.fare[0]" class="col-md-12 bold row"style="padding-left: 23px;padding-top: 4px;">
                  <!-- <mat-checkbox (click)="setStep(0)" color="primary" class="example-ripple-checkbox">{{item.fare[0].fareType}}</mat-checkbox>                        -->
          
                  <span (click)="setStep(0)" color="primary" >
                    <!-- {{item.fare[0]?.corporateFare?("Corporate"):item.fare[0].fareType}} -->
                    {{item.fare[0]?.fareTypeDisplay}}

                  </span>                       
                </div> 
          
                  <!-- <div class="col md-7"  ><span style=" color:rgb(1,123,254);cursor: pointer; font-weight: 600;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">&#8377;{{item.fare[0].baseFare+item.fare[0]?.finalTax}} </span></div> -->
          </div>
          
          <ng-template #popoverContent class="col-md-12"  >
            <div class="  col-md-12 ">
          
            <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                          style="overflow-y:scroll;max-height: 95%; width: 100%;">
                          <thead class="thead-light" style="white-space:nowrap;">
                            <tr>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                              <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
          
          
          
                            </tr>
                          </thead>
                          <tbody >
                            <tr  style="height: 25px; ">
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].baseFare}}</td>
                            
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].finalTax}}</td>
                              <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                {{
                                  (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                }}</td>
                            
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{
                                (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                  (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                  (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                
                              }}</td> -->
          
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                            
                            
                            </tr>
                          </tbody>
                        </table>
                        <div class=" mt-1" *ngIf="messageData.adultCount">
                          <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                           <span> {{passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
          
                                      <!-- remove in hover only -->
          
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
                      <div class=" mt-1" *ngIf="messageData.childCount">
                        <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                        <span> {{passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
          
                                      <!-- remove in hover only -->
          
                          <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                            {{ entry.key }}{{ entry.value | json }},
                           </span>) -->
                        </span>
                        
                     
                    </div>
                    <div class=" mt-1" *ngIf="messageData.infantCount">
                      <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                      <span> {{passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
                                      <!-- remove in hover only -->
          
          
                        <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                          {{ entry.key }}{{ entry.value | json }},
                         </span>) -->
                      </span>
                      
                   
                  </div>
          
            </div>
            </ng-template>
          
          
          
          
          
              
            </div>
            
            </div>
          <div *ngIf="!enableCheck" class="col-md-1" style="width: 40px;" class="d-flex justify-content-end">
                  
            <button *ngIf="item?.dropDown===false"  mat-icon-button (click)="selectRFlight(item);onClickDropdown(item)" >
              <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
            </button>  
            <button *ngIf="item?.dropDown===true" mat-icon-button  (click)="onClickDropup(item)">
              <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
            </button>
           
          </div>
          </mat-panel-title>
         
        
          
      </mat-expansion-panel-header>
      
      
  
      <div *ngIf="item?.dropDown===true" class="col-md-12 row">
        <table class="styled-tables " style="white-space:nowrap; ">
          <thead>
            <tr  >
              <!-- Dynamic headers based on tableHeaders array -->
              <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
              <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
              <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
              <th style="padding: 8px;  text-align: center;text-align: left;"></th>
  
            </tr>
          </thead>
          <tbody class="box-shadow">
            <!-- Iterate through dynamic data rows -->
            <tr  *ngFor="let fare of item?.fare;" >
              <!-- Display structured data -->
              
              <td class="" style="padding: 8px;" [style]="fare.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
                <span class="col-md-12 row">
                  <span class="col-md-10">
                    <mat-checkbox color="primary"  *ngIf="enableCheck"  (change)="selectRShareData($event,item,fare)"></mat-checkbox>
                    <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }} -->
                    
                    {{fare?.fareTypeDisplay }}
                    <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(false,true,false,false);onClickITINERARYTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    
                    <br><small *ngIf="parentType==='Staff'" style="color: rgb(194, 129, 8);">{{fare?.source}}</small>  

                   </span>
            </span>
              </td>
              <td class="" style="padding: 8px;">
               {{fare?.refundable===true?('Refundable'):''}}
                {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}
                <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(false,true,false,false);onClickCancellationTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    

              </td>
              <!-- <td class="name-type" style="padding: 8px;">
               
              </td> -->
              <td class="" style="padding: 8px;">
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
              
              </td>
              <td class="" style="padding: 8px;">{{fareOMapping(fare,item,item?.fare)[0]?.seatsAvailability}}</td>
              <td class="" style="padding: 8px;">
                <!-- change fun fareOMapping -->
                {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}
  
                 <!-- {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG'):"N/A"}} -->
              </td>
              <td class="" style="padding: 8px;">{{'7KG' }}</td>
              <td  style="padding: 8px;">
               <!-- <mat-radio-group class="col-md-12"
               aria-labelledby="example-radio-group-label"
               class="example-radio-group"
               [(ngModel)]="fare.selected" 
               >
               
               <mat-radio-button color="primary" class="example-radio-button "  (click)="onClickRFare(fare, item.fare,item)" value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
               </mat-radio-group> -->
               <span (click)="onClickRFare(fare, item.fare,item)">
                <mat-icon class="mat-primary" *ngIf="fare.selected==='true'">radio_button_checked</mat-icon>
                <mat-icon style="color: #757575;" *ngIf="fare.selected===''">radio_button_unchecked</mat-icon>
                <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                triggers="mouseenter:mouseleave">
               
                ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}} <br>
                <span *ngIf="Incv" style="color: grey;font-size: 12px;"> Incv ₹{{fare?.incentiveAmt}}&nbsp;</span>
                <span *ngIf="net" style="color: grey;font-size: 12px;">  Net ₹{{fare?.netFare}}&nbsp;</span> 
  
                <!-- ₹{{(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  fare?.commercialData?.finalAmount}} -->
               </span>
  
              </span>  
  
              <ng-template #popoverContent class="col-md-12"  >
                <div class="  col-md-12 ">
  
                <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                              style="overflow-y:scroll;max-height: 95%; width: 100%;">
                              <thead class="thead-light" style="white-space:nowrap;">
                                <tr>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                  <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
  
  
  
                                </tr>
                              </thead>
                              <tbody >
                                <tr  style="height: 25px; ">
                                  <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                    (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                    }}</td>
                                
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                      (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                    }}</td> -->
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare?.baseFare}}</td>
                              
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare?.finalTax}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                    
                                    
                                
                                </tr>
                              </tbody>
                            </table>
                            <div class=" mt-1" *ngIf="messageData.adultCount">
                              <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                               <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                  {{ entry.key }}{{ entry.value | json }},
                                 </span>) -->
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.childCount">
                            <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                            <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                        <div class=" mt-1" *ngIf="messageData.infantCount">
                          <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                          <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
  
                </div>
                </ng-template>
              </td>
  
            </tr>
          </tbody>
        </table>
       
      </div>
      
    </mat-expansion-panel>
    </mat-accordion>
  </div>
  </span>
 <!-------------################## 3rdTAb   ###############-->
    <!-------------################## 3rdTAb   ###############-->
  <!-------------################## 3rdTAb   ###############-->

  <span class="col-md-12"  [style]="multiSelectedTAB!=2?('display:none'):'display:block'">
    <!-- style="height: 38vh; overflow-y: auto;" -->
    <div >
      <mat-accordion class="example-headers-align" multi style="margin-top: 10px;">
  
    <mat-expansion-panel  [ngClass]="{'active' :activeThird(item)}"  *ngFor="let item of thirdFlightDetail" [expanded]="item.selected" disabled hideToggle  style="margin-top: 5px; margin-left: 10px;margin-right: 10px; ">
      <mat-expansion-panel-header style="min-height:80px;">
        <mat-panel-title style="color: rgb(33,33,33);" class="row">
          <div class="col-md-1">
            <img  [src]="flightlogoFilter(item?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">
  
                </div>
          <div style="font-size: 14px; " class="col-md-2">
          {{fligthNameFilter(item?.flightDetailsList[0]?.carrierName)}}
          <span style="font-size: 13px; color: grey; white-space:nowrap;">{{item?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flightDetailsList[0]?.flightNumber}}
            <br>
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" style="padding-left: 6px;" *ngIf="distancePlus(item?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flightDetailsList)}}</span>
  
          </span>
  
          </div>
         
          <div class="col-md-8 row mt-3"  style="white-space: nowrap;">
                
            <div class="col-md-3 bold" >{{ item?.schDepartureTime | date:'HH:mm'}}</div>
            <div class="col-md-3">
              
            <span >{{converter(item?.travelDuration)}} </span> 
            <div *ngIf="item?.hopCount===1" style="border-bottom:2px solid rgb(10, 210, 60) ;width: 30%;" ></div>
            <div *ngIf="item?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;width: 30%;"></div>
            <div *ngIf="item?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;width: 30%;"></div>
  
              <span class="d-flex justify-content-start" *ngIf="item?.hopCount===1" (click)="popoveritemTContent.toggle($event)" style="font-size: 13px; color: grey;align-items: start; ">{{item?.hopCount===1?('non-stop'):''}}</span>
              <span class="d-flex justify-content-start" *ngIf="item?.hopCount!=1" (click)="popoveritemTContent.toggle($event)" style="font-size: 13px; color: grey; align-items: start;">&nbsp;&nbsp;{{item?.hopCount?(item?.hopCount-1+'-'+'stop'):''}}</span>
              <p-overlayPanel  #popoveritemTContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of item.flightDetailsList">
          
          <div class="mb-3 mt-1">
            <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
        </div><br>
      <div class="col-md-2">
        <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
    
      
    <br>
    {{fligthNameFilter(element?.carrierName)}}<br>
        <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
          <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
          <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
         <!--<span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
        -->
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
          <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
    
        </span>
    </div>
    
    <div class="col-md-2">
        {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
        <br>
        <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
    </div>
    <div class="col-md-2">
        <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
        <br>
        <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
       
    </div>
    <div class="col-md-2">
      {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
        <br>
        <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
    </div>
    <div class="col-md-2">
            
        <!-- <span style="font-size: 12px;">Check-in baggage</span>
        <br>
        <span style="font-size: 12px;">  Cabin baggage</span> -->
    </div>
    <div class="col-md-2">
        <!-- <span style="font-size: 13px;">20kg/ Adult</span>
         <br>
         <span style="font-size: 13px;">7kg/ Adult</span> -->
     </div>
        </div>
      </p-overlayPanel>
            </div>
            <div class="col-md-3 bold" >{{item?.schArrivalTime | date:'HH:mm'}}
              <small style="color: red;font-size: 12px;" ngbPopover="{{item?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
                    triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.schDepartureTime,item?.schArrivalTime)}}</small>
            </div>
          
            <div class="col-md-3  d-flex justify-content-center">



              <div  class="col-md-12 row " [style]="item?.fare[0]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item?.fare[0]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item.fare[0]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
                <div *ngIf="item.fare[0]" class="col-md-12 row">
                  <div class="col-md-12 " (click)="setStep(0)" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;"> 
                    <span *ngIf="!enableCheck"  (click)="onClickTFare(item.fare[0], item.fare,item)">
                    <mat-icon class="mat-primary" *ngIf="item.fare[0].selected==='true'">radio_button_checked</mat-icon>
                    <mat-icon style="color: #757575;" *ngIf="item.fare[0].selected===''">radio_button_unchecked</mat-icon>
                    
                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">
                    ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
                    <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      item?.fare[0]?.commercialData?.finalAmount}} -->
                    </span> 
          
                  </span>    
                  <span *ngIf="enableCheck" >
                    <!-- <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectShareData($event,item,item?.fare[0])"></mat-checkbox> -->
          
                    <!-- <mat-icon *ngIf="enableCheck" style=" color: #757575;">check_box_outline_blank</mat-icon>
                    <mat-icon *ngIf="false"  class="mat-primary">check_box</mat-icon> -->
                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">
                    ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
                    <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      item?.fare[0]?.commercialData?.finalAmount}} -->
                    </span> 
          
                  </span>        
                    <!-- <mat-radio-group (click)="setStep(0)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="item.fare[0].selected" >
                      <mat-radio-button  color="primary" class="example-radio-button "  (click)="onClickFare(item.fare[0], item.fare,item)"  value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;font-size: 18px;">₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax}}</span></mat-radio-button>
                    </mat-radio-group> -->
                    
                  </div>
                   
                </div>
                 <!-- <div class="col-md-12 row" >
                      <span class="col-md-1 "></span>
                      <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 10px;">{{item?.fare[0]?.refundable===true?('Refundable'):''}}</span>
                      <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 10px;"> {{item?.fare[0]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
                      <span class="col-md-1 "></span>
                      <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                      <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
                    </div> -->
                <div *ngIf="item.fare[0]" class="col-md-12 bold row"style="padding-left: 23px;padding-top: 4px;">
                  <!-- <mat-checkbox (click)="setStep(0)" color="primary" class="example-ripple-checkbox">{{item.fare[0].fareType}}</mat-checkbox>                        -->
          
                  <span (click)="setStep(0)" color="primary" >
                    <!-- {{item.fare[0]?.corporateFare?("Corporate"):item.fare[0].fareType}} -->
                    {{item.fare[0]?.fareTypeDisplay}}

                  </span>                       
                </div> 
          
                  <!-- <div class="col md-7"  ><span style=" color:rgb(1,123,254);cursor: pointer; font-weight: 600;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">&#8377;{{item.fare[0].baseFare+item.fare[0]?.finalTax}} </span></div> -->
          </div>
          
          <ng-template #popoverContent class="col-md-12"  >
            <div class="  col-md-12 ">
          
            <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                          style="overflow-y:scroll;max-height: 95%; width: 100%;">
                          <thead class="thead-light" style="white-space:nowrap;">
                            <tr>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                              <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
          
          
          
                            </tr>
                          </thead>
                          <tbody >
                            <tr  style="height: 25px; ">
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].baseFare}}</td>
                            
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].finalTax}}</td>
                              <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                {{
                                  (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                }}</td>
                            
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{
                                (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                  (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                  (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                
                              }}</td> -->
          
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                            
                            
                            </tr>
                          </tbody>
                        </table>
                        <div class=" mt-1" *ngIf="messageData.adultCount">
                          <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                           <span> {{passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
          
                                      <!-- remove in hover only -->
          
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
                      <div class=" mt-1" *ngIf="messageData.childCount">
                        <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                        <span> {{passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
          
                                      <!-- remove in hover only -->
          
                          <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                            {{ entry.key }}{{ entry.value | json }},
                           </span>) -->
                        </span>
                        
                     
                    </div>
                    <div class=" mt-1" *ngIf="messageData.infantCount">
                      <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                      <span> {{passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
                                      <!-- remove in hover only -->
          
          
                        <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                          {{ entry.key }}{{ entry.value | json }},
                         </span>) -->
                      </span>
                      
                   
                  </div>
          
            </div>
            </ng-template>
          
          
          
          
          
              
            </div>
            </div>
          <div *ngIf="!enableCheck" class="col-md-1" style="width: 40px;" class="d-flex justify-content-end">
                  
            <button *ngIf="item?.dropDown===false"  mat-icon-button (click)="selectTFlight(item);onClickTDropdown(item)" >
              <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
            </button>  
            <button *ngIf="item?.dropDown===true" mat-icon-button  (click)="onClickTDropup(item)">
              <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
            </button>
           
          </div>
          </mat-panel-title>
         
        
          
      </mat-expansion-panel-header>
      
      
  
      <div *ngIf="item?.dropDown===true" class="col-md-12 row">
        <table class="styled-tables " style="white-space:nowrap; ">
          <thead>
            <tr  >
              <!-- Dynamic headers based on tableHeaders array -->
              <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
              <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
              <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
              <th style="padding: 8px;  text-align: center;text-align: left;"></th>
  
            </tr>
          </thead>
          <tbody class="box-shadow">
            <!-- Iterate through dynamic data rows -->
            <tr  *ngFor="let fare of item?.fare;" >
              <!-- Display structured data -->
              
              <td class="" style="padding: 8px;" [style]="fare.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
                <span class="col-md-12 row">
                  <span class="col-md-10">
                    <mat-checkbox color="primary"  *ngIf="enableCheck"  (change)="selectTShareData($event,item,fare)"></mat-checkbox>
  
                    <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }} -->
                    {{fare?.fareTypeDisplay }}
                    
                    <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(false,false,true,false);onClickITINERARYTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    
                    <br><small *ngIf="parentType==='Staff'" style="color: rgb(194, 129, 8);">{{fare?.source}}</small>  

                  </span>
            </span>
              </td>
              <td class="" style="padding: 8px;">
               {{fare?.refundable===true?('Refundable'):''}}
              {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}
                <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(false,false,true,false);onClickCancellationTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    

              </td>
              <!-- <td class="name-type" style="padding: 8px;">
               
              </td> -->
              <td class="" style="padding: 8px;">
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
              
              </td>
              <td class="" style="padding: 8px;">{{fareOMapping(fare,item,item?.fare)[0]?.seatsAvailability}}</td>
              <td class="" style="padding: 8px;">
                <!-- change fun fareOMapping -->
                {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}
  
                 <!-- {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG'):"N/A"}} -->
              </td>
              <td class="" style="padding: 8px;">{{'7KG' }}</td>
              <td  style="padding: 8px;">
               <!-- <mat-radio-group class="col-md-12"
               aria-labelledby="example-radio-group-label"
               class="example-radio-group"
               [(ngModel)]="fare.selected" 
               >
               
               <mat-radio-button color="primary" class="example-radio-button "  (click)="onClickRFare(fare, item.fare,item)" value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
               </mat-radio-group> -->
               <span (click)="onClickTFare(fare, item.fare,item)">
                <mat-icon class="mat-primary" *ngIf="fare.selected==='true'">radio_button_checked</mat-icon>
                <mat-icon style="color: #757575;" *ngIf="fare.selected===''">radio_button_unchecked</mat-icon>
                <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                triggers="mouseenter:mouseleave">
               
                ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}}<br>
                <span *ngIf="Incv" style="color: grey;font-size: 12px;"> Incv ₹{{fare?.incentiveAmt}}&nbsp;</span>
                <span *ngIf="net" style="color: grey;font-size: 12px;">  Net ₹{{fare?.netFare}}&nbsp;</span> 
  
                <!-- ₹{{(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  fare?.commercialData?.finalAmount}} -->
                </span>
  
              </span>  
  
              <ng-template #popoverContent class="col-md-12"  >
                <div class="  col-md-12 ">
  
                <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                              style="overflow-y:scroll;max-height: 95%; width: 100%;">
                              <thead class="thead-light" style="white-space:nowrap;">
                                <tr>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                  <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
  
  
  
                                </tr>
                              </thead>
                              <tbody >
                                <tr  style="height: 25px; ">
                                  <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                    (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                    }}</td>
                                
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                      (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                    }}</td> -->
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.baseFare}}</td>
                              
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.finalTax}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                    
                                    
                                
                                </tr>
                              </tbody>
                            </table>
                            <div class=" mt-1" *ngIf="messageData.adultCount">
                              <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                               <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                  {{ entry.key }}{{ entry.value | json }},
                                 </span>) -->
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.childCount">
                            <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                            <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                        <div class=" mt-1" *ngIf="messageData.infantCount">
                          <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                          <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
  
                </div>
                </ng-template>
              </td>
  
            </tr>
          </tbody>
        </table>
       
      </div>
      
    </mat-expansion-panel>
    </mat-accordion>
  </div>
  </span>

<!-------------################## 4thTAb   ###############-->
    <!-------------################## 4thTAb   ###############-->
  <!-------------################## 4thTAb   ###############-->

  <span class="col-md-12"  [style]="multiSelectedTAB!=3?('display:none'):'display:block'">
    <!-- style="height: 38vh; overflow-y: auto;" -->
    <div >
      <mat-accordion class="example-headers-align" multi style="margin-top: 10px;">
  
    <mat-expansion-panel  [ngClass]="{'active' :activeFourth(item)}"  *ngFor="let item of fourthFlightDetail" [expanded]="item.selected" disabled hideToggle  style="margin-top: 5px; margin-left: 10px;margin-right: 10px; ">
      <mat-expansion-panel-header style="min-height:80px;">
        <mat-panel-title style="color: rgb(33,33,33);" class="row">
          <div class="col-md-1">
            <img  [src]="flightlogoFilter(item?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">
  
                </div>
          <div style="font-size: 14px; " class="col-md-2">
          {{fligthNameFilter(item?.flightDetailsList[0]?.carrierName)}}
          <span style="font-size: 13px; color: grey; white-space:nowrap;">{{item?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flightDetailsList[0]?.flightNumber}}
            <br>
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" style="padding-left: 6px;" *ngIf="distancePlus(item?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flightDetailsList)}}</span>
  
          </span>
  
          </div>
         
          <div class="col-md-8 row mt-3"  style="white-space: nowrap;">
                
            <div class="col-md-3 bold" >{{ item?.schDepartureTime | date:'HH:mm'}}</div>
            <div class="col-md-3">
              
            <span >{{converter(item?.travelDuration)}} </span> 
            <div *ngIf="item?.hopCount===1" style="border-bottom:2px solid rgb(10, 210, 60) ;width: 30%;" ></div>
            <div *ngIf="item?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;width: 30%;"></div>
            <div *ngIf="item?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;width: 30%;"></div>
  
              <span class="d-flex justify-content-start" *ngIf="item?.hopCount===1" (click)="popoveritemFContent.toggle($event)" style="font-size: 13px; color: grey;align-items: start; ">{{item?.hopCount===1?('non-stop'):''}}</span>
              <span class="d-flex justify-content-start" *ngIf="item?.hopCount!=1" (click)="popoveritemFContent.toggle($event)" style="font-size: 13px; color: grey; align-items: start;">&nbsp;&nbsp;{{item?.hopCount?(item?.hopCount-1+'-'+'stop'):''}}</span>
              <p-overlayPanel  #popoveritemFContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of item.flightDetailsList">
          
          <div class="mb-3 mt-1">
            <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
        </div><br>
      <div class="col-md-2">
        <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
    
      
    <br>
    {{fligthNameFilter(element?.carrierName)}}<br>
        <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
          <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
          <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
         <!--<span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
        -->
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
          <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
    
        </span>
    </div>
    
    <div class="col-md-2">
        {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
        <br>
        <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
    </div>
    <div class="col-md-2">
        <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
        <br>
        <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
       
    </div>
    <div class="col-md-2">
      {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
        <br>
        <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
        <br>
        <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
    </div>
    <div class="col-md-2">
            
        <!-- <span style="font-size: 12px;">Check-in baggage</span>
        <br>
        <span style="font-size: 12px;">  Cabin baggage</span> -->
    </div>
    <div class="col-md-2">
        <!-- <span style="font-size: 13px;">20kg/ Adult</span>
         <br>
         <span style="font-size: 13px;">7kg/ Adult</span> -->
     </div>
        </div>
      </p-overlayPanel>
            </div>
            <div class="col-md-3 bold" >{{item?.schArrivalTime | date:'HH:mm'}}
              <small style="color: red;font-size: 12px;" ngbPopover="{{item?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
                    triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.schDepartureTime,item?.schArrivalTime)}}</small>
            </div>
          
            <div class="col-md-3  d-flex justify-content-center">



              <div  class="col-md-12 row " [style]="item?.fare[0]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item?.fare[0]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item.fare[0]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
                <div *ngIf="item.fare[0]" class="col-md-12 row">
                  <div class="col-md-12 " (click)="setStep(0)" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;"> 
                    <span *ngIf="!enableCheck"  (click)="onClickFFare(item.fare[0], item.fare,item)">
                    <mat-icon class="mat-primary" *ngIf="item.fare[0].selected==='true'">radio_button_checked</mat-icon>
                    <mat-icon style="color: #757575;" *ngIf="item.fare[0].selected===''">radio_button_unchecked</mat-icon>
                    
                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">
                    ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
                    <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      item?.fare[0]?.commercialData?.finalAmount}} -->
                    </span> 
          
                  </span>    
                  <span *ngIf="enableCheck" >
                    <!-- <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectShareData($event,item,item?.fare[0])"></mat-checkbox> -->
          
                    <!-- <mat-icon *ngIf="enableCheck" style=" color: #757575;">check_box_outline_blank</mat-icon>
                    <mat-icon *ngIf="false"  class="mat-primary">check_box</mat-icon> -->
                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">
                    ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} 
                    <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      item?.fare[0]?.commercialData?.finalAmount}} -->
                    </span> 
          
                  </span>        
                    <!-- <mat-radio-group (click)="setStep(0)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="item.fare[0].selected" >
                      <mat-radio-button  color="primary" class="example-radio-button "  (click)="onClickFare(item.fare[0], item.fare,item)"  value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;font-size: 18px;">₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax}}</span></mat-radio-button>
                    </mat-radio-group> -->
                    
                  </div>
                   
                </div>
                 <!-- <div class="col-md-12 row" >
                      <span class="col-md-1 "></span>
                      <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 10px;">{{item?.fare[0]?.refundable===true?('Refundable'):''}}</span>
                      <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 10px;"> {{item?.fare[0]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
                      <span class="col-md-1 "></span>
                      <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                      <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
                    </div> -->
                <div *ngIf="item.fare[0]" class="col-md-12 bold row"style="padding-left: 23px;padding-top: 4px;">
                  <!-- <mat-checkbox (click)="setStep(0)" color="primary" class="example-ripple-checkbox">{{item.fare[0].fareType}}</mat-checkbox>                        -->
          
                  <span (click)="setStep(0)" color="primary" >
                    
                    <!-- {{item.fare[0]?.corporateFare?("Corporate"):item.fare[0].fareType}} -->
                    {{item.fare[0]?.fareTypeDisplay}}
                    
                  </span>                       
                </div> 
          
                  <!-- <div class="col md-7"  ><span style=" color:rgb(1,123,254);cursor: pointer; font-weight: 600;" [ngbPopover]="popoverContent" container="body"
                    triggers="mouseenter:mouseleave">&#8377;{{item.fare[0].baseFare+item.fare[0]?.finalTax}} </span></div> -->
          </div>
          
          <ng-template #popoverContent class="col-md-12"  >
            <div class="  col-md-12 ">
          
            <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                          style="overflow-y:scroll;max-height: 95%; width: 100%;">
                          <thead class="thead-light" style="white-space:nowrap;">
                            <tr>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                              <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                              <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
          
          
          
                            </tr>
                          </thead>
                          <tbody >
                            <tr  style="height: 25px; ">
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].baseFare}}</td>
                            
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].finalTax}}</td>
                              <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                {{
                                  (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                }}</td>
                            
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{
                                (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                  (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                  (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                
                              }}</td> -->
          
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                              <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                            
                            
                            </tr>
                          </tbody>
                        </table>
                        <div class=" mt-1" *ngIf="messageData.adultCount">
                          <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                           <span> {{passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
          
                                      <!-- remove in hover only -->
          
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
                      <div class=" mt-1" *ngIf="messageData.childCount">
                        <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                        <span> {{passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
          
                                      <!-- remove in hover only -->
          
                          <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                            {{ entry.key }}{{ entry.value | json }},
                           </span>) -->
                        </span>
                        
                     
                    </div>
                    <div class=" mt-1" *ngIf="messageData.infantCount">
                      <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                      <span> {{passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
                                      <!-- remove in hover only -->
          
          
                        <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                          {{ entry.key }}{{ entry.value | json }},
                         </span>) -->
                      </span>
                      
                   
                  </div>
          
            </div>
            </ng-template>
          
          
          
          
          
              
            </div>
            </div>
          <div *ngIf="!enableCheck" class="col-md-1" style="width: 40px;" class="d-flex justify-content-end">
                  
            <button *ngIf="item?.dropDown===false"  mat-icon-button (click)="selectFFlight(item);onClickFDropdown(item)" >
              <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
            </button>  
            <button *ngIf="item?.dropDown===true" mat-icon-button  (click)="onClickFDropup(item)">
              <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
            </button>
           
          </div>
          </mat-panel-title>
         
        
          
      </mat-expansion-panel-header>
      
      
  
      <div *ngIf="item?.dropDown===true" class="col-md-12 row">
        <table class="styled-tables " style="white-space:nowrap; ">
          <thead>
            <tr  >
              <!-- Dynamic headers based on tableHeaders array -->
              <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
              <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
              <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
              <th style="padding: 8px;  text-align: center;text-align: left;"></th>
  
            </tr>
          </thead>
          <tbody class="box-shadow">
            <!-- Iterate through dynamic data rows -->
            <tr  *ngFor="let fare of item?.fare;" >
              <!-- Display structured data -->
              
              <td class="" style="padding: 8px;" [style]="fare?.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
                <span class="col-md-12 row">
                  <span class="col-md-10">
                    <mat-checkbox color="primary"  *ngIf="enableCheck"  (change)="selectFShareData($event,item,fare)"></mat-checkbox>
  
                    <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }} -->
                    {{fare?.fareTypeDisplay }}
                    
                    <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(false,false,false,true);onClickITINERARYTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    
                    <br><small *ngIf="parentType==='Staff'" style="color: rgb(194, 129, 8);">{{fare?.source}}</small>  

                  </span>
            </span>
              </td>
              <td class="" style="padding: 8px;">
               {{fare?.refundable===true?('Refundable'):''}}
               {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}
                <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openReturnPopup(false,false,false,true);onClickCancellationTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    

              </td>
              <!-- <td class="name-type" style="padding: 8px;">
               
              </td> -->
              <td class="" style="padding: 8px;">
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
              
              </td>
              <td class="" style="padding: 8px;">{{fareOMapping(fare,item,item?.fare)[0]?.seatsAvailability}}</td>
              <td class="" style="padding: 8px;">
                <!-- change fun fareOMapping -->
                {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}
  
                 <!-- {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG'):"N/A"}} -->
              </td>
              <td class="" style="padding: 8px;">{{'7KG' }}</td>
              <td  style="padding: 8px;">
               <!-- <mat-radio-group class="col-md-12"
               aria-labelledby="example-radio-group-label"
               class="example-radio-group"
               [(ngModel)]="fare.selected" 
               >
               
               <mat-radio-button color="primary" class="example-radio-button "  (click)="onClickRFare(fare, item.fare,item)" value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
               </mat-radio-group> -->
               <span (click)="onClickFFare(fare, item.fare,item)">
                <mat-icon class="mat-primary" *ngIf="fare.selected==='true'">radio_button_checked</mat-icon>
                <mat-icon style="color: #757575;" *ngIf="fare.selected===''">radio_button_unchecked</mat-icon>
                <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                triggers="mouseenter:mouseleave">
                
               
                ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}}<br>
                <span *ngIf="Incv" style="color: grey;font-size: 12px;"> Incv ₹{{fare?.incentiveAmt}}&nbsp;</span>
                <span *ngIf="net" style="color: grey;font-size: 12px;">  Net ₹{{fare?.netFare}}&nbsp;</span> 
  
                <!-- ₹{{(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                  (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                  fare?.commercialData?.finalAmount}} -->
                 </span>
  
              </span>  
  
              <ng-template #popoverContent class="col-md-12"  >
                <div class="  col-md-12 ">
  
                <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                              style="overflow-y:scroll;max-height: 95%; width: 100%;">
                              <thead class="thead-light" style="white-space:nowrap;">
                                <tr>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                  <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
  
  
  
                                </tr>
                              </thead>
                              <tbody >
                                <tr  style="height: 25px; ">
                                  <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                    (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                    }}</td>
                                
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                      (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                    }}</td> -->
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.baseFare}}</td>
                              
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.finalTax}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                    
                                    
                                
                                </tr>
                              </tbody>
                            </table>
                            <div class=" mt-1" *ngIf="messageData.adultCount">
                              <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                               <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                  {{ entry.key }}{{ entry.value | json }},
                                 </span>) -->
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.childCount">
                            <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                            <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                        <div class=" mt-1" *ngIf="messageData.infantCount">
                          <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                          <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
  
                </div>
                </ng-template>
              </td>
  
            </tr>
          </tbody>
        </table>
       
      </div>
      
    </mat-expansion-panel>
    </mat-accordion>
  </div>
  </span>


  </span>





<!-- ###################################   Multi Totals ##################################################
     ###################################  Multi Totals ################################################## 
      ################################### Multi Totals ################################################## -->
 
      <mat-expansion-panel class="col-md-12 tabActives sticky-search-tabs"  *ngIf="messageData.airSearchRequestBaseDetails.length>0 && this.returnflight[0]?.flights.length>0" hideToggle disabled   >
        <!-- <mat-expansion-panel-header class="col-md-12">
          <div *ngIf="departureFlight" class="col-md-12 row">
            <div class="col-md-6 d-flex justify-content-start" style="color:rgb(32,32,32);">
              <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( returnflight[0]?.fromAirport)}} to {{cityFilter(returnflight[0]?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>
          </div>
          <div *ngIf="returnFlight" class="col-md-6 d-flex justify-content-start" style="color:rgb(32,32,32);">
            <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( returnflight[1]?.fromAirport)}} to {{cityFilter(returnflight[1]?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>
          </div>
          </div>
          </mat-expansion-panel-header> -->
        <mat-expansion-panel-header class="col-md-12 pt-3">
          <mat-panel-description style="color:white;  border-right:1px solid white; ">

           
            <span style="font-size: 14px; min-width: 10%">
                <img  [src]="flightlogoFilter(departureFlight?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

                <br>
            {{fligthNameFilter(departureFlight?.flightDetailsList[0]?.carrierName)}}
            </span>
            &nbsp;&nbsp;
            <span class="" style="white-space: nowrap;">
                <span >{{ departureFlight?.flightDetailsList[0]?.fromAirport+'-'+departureFlight?.flightDetailsList[departureFlight?.flightDetailsList.length-1]?.toAirport}}</span>
                <br>
                <span class="bold">
                  ₹{{departureFlight?.fare[0]?.baseFare+departureFlight?.fare[0]?.finalTax+departureFlight.fare[0].commercialData?.finalAmount}}
                     <!-- (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                    departureFlight?.fare[0].commercialData?.finalAmount -->
                  
                  </span>
                  
                <!-- <span >{{ departureFlight?.schDepartureTime | date:'hh:mm a'}}</span>
                &nbsp;&nbsp;
                <span >{{converter(departureFlight?.travelDuration)}} </span>
                &nbsp;&nbsp;
                <span >{{departureFlight?.schArrivalTime | date:'hh:mm a'}}</span> -->
               
              
            </span>
            </mat-panel-description>
    <!-- <mat-panel-title style="padding: 0; margin: 0;" class="d-flex justify-content-center"><span >
      <img  src="../../../assets/images/comparearrows.png" width="50" height="50" alt="">
    </span></mat-panel-title> -->

    <mat-panel-description *ngIf="returnFlight" style="color:white;border-right:1px solid white;"  >
    

      
        <span style="font-size: 14px; min-width: 10%">
            <img  [src]="flightlogoFilter(returnFlight?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

            <br>
        {{fligthNameFilter(returnFlight?.flightDetailsList[0]?.carrierName)}}

        </span>
        
        &nbsp;&nbsp;
        <span class="" style="white-space: nowrap;">
          <span >{{returnFlight?.flightDetailsList[0]?.fromAirport+'-'+returnFlight?.flightDetailsList[returnFlight?.flightDetailsList.length-1]?.toAirport}}</span>
<br>
<span class="bold">
  ₹{{returnFlight?.fare[0]?.baseFare+returnFlight?.fare[0]?.finalTax+returnFlight.fare[0].commercialData?.finalAmount}}
  <!-- (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
  (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
  (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
  (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
   (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
   (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
  returnFlight?.fare[0].commercialData?.finalAmount -->
</span>
          <!-- <span >{{ returnFlight?.fromAirport+'-'+returnFlight?.toAirport}}</span> -->
         
            <!-- <span >{{ returnFlight?.schDepartureTime | date:'hh:mm a'}}</span>
            &nbsp;&nbsp;
            <span >{{converter(returnFlight?.travelDuration)}} </span>
            &nbsp;&nbsp;
            <span >{{returnFlight?.schArrivalTime | date:'hh:mm a'}}</span> -->
           
           
            
        </span>
               </mat-panel-description>

            <mat-panel-description *ngIf="thirdFlight" style="color:white;border-right:1px solid white;"  >
    

            
              <span style="font-size: 14px; min-width: 10%">
                <img  [src]="flightlogoFilter(thirdFlight?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

                <br>
              {{fligthNameFilter(thirdFlight?.flightDetailsList[0]?.carrierName)}}
    
              </span>
              
              &nbsp;&nbsp;
              <span class="" style="white-space: nowrap;">
                <span >{{ thirdFlight?.flightDetailsList[0]?.fromAirport+'-'+thirdFlight?.flightDetailsList[thirdFlight?.flightDetailsList.length-1]?.toAirport}}</span>
                <br>
                <span class="bold">
                  ₹{{thirdFlight?.fare[0]?.baseFare+thirdFlight?.fare[0]?.finalTax+thirdFlight.fare[0].commercialData?.finalAmount}}
                     <!-- (passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                    
                    thirdFlight?.fare[0].commercialData?.finalAmount -->
                  </span>
                  
                <!-- <span >{{ returnFlight?.fromAirport+'-'+returnFlight?.toAirport}}</span> -->
               
                  <!-- <span >{{ returnFlight?.schDepartureTime | date:'hh:mm a'}}</span>
                  &nbsp;&nbsp;
                  <span >{{converter(returnFlight?.travelDuration)}} </span>
                  &nbsp;&nbsp;
                  <span >{{returnFlight?.schArrivalTime | date:'hh:mm a'}}</span> -->
                 
                 
                  
              </span>
                     </mat-panel-description>
                     <mat-panel-description *ngIf="fourthFlight" style="color:white;border-right:1px solid white;"  >
    
          
                      
                        
                        <span style="font-size: 14px; min-width: 10%">
                            <img  [src]="flightlogoFilter(fourthFlight?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

                         <br>
                        {{fligthNameFilter(fourthFlight?.flightDetailsList[0]?.carrierName)}}
              
                        </span>
                        
                        &nbsp;&nbsp;
                        <span class="" style="white-space: nowrap;">
                          <span >{{ fourthFlight?.flightDetailsList[0]?.fromAirport+'-'+fourthFlight?.flightDetailsList[fourthFlight?.flightDetailsList.length-1]?.toAirport}}</span>
                          <br>
                          <span class="bold">
                            ₹{{fourthFlight?.fare[0]?.baseFare+fourthFlight?.fare[0]?.finalTax+fourthFlight.fare[0].commercialData?.finalAmount}}
                              <!-- (passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                              (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                              (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                              (passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                               (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                               (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                              fourthFlight?.fare[0].commercialData?.finalAmount-->
                            </span> 
                            
                          <!-- <span >{{ returnFlight?.fromAirport+'-'+returnFlight?.toAirport}}</span> -->
                         
                            <!-- <span >{{ returnFlight?.schDepartureTime | date:'hh:mm a'}}</span>
                            &nbsp;&nbsp;
                            <span >{{converter(returnFlight?.travelDuration)}} </span>
                            &nbsp;&nbsp;
                            <span >{{returnFlight?.schArrivalTime | date:'hh:mm a'}}</span> -->
                           
                           
                            
                        </span>
                               </mat-panel-description>

                               <span class="pt-4" style="font-size: 18px; font-weight: bold;color: white"> 
                                ₹ {{(returnFlight?(returnFlight?.fare[0]?.baseFare+returnFlight?.fare[0]?.finalTax+returnFlight?.fare[0].commercialData?.finalAmount):0)+
                                  (departureFlight?(departureFlight?.fare[0]?.baseFare+departureFlight?.fare[0]?.finalTax+departureFlight.fare[0].commercialData?.finalAmount):0)+
                                  (thirdFlight?(thirdFlight?.fare[0]?.baseFare+thirdFlight?.fare[0]?.finalTax+thirdFlight.fare[0].commercialData?.finalAmount):0)+
                                  (fourthFlight?(fourthFlight?.fare[0]?.baseFare+fourthFlight?.fare[0]?.finalTax+fourthFlight?.fare[0]?.commercialData?.finalAmount):0)}}</span>




                     
                     <!--<span style="font-size: 18px; font-weight: bold;color: rgb(33,33,33);">
                     ₹ {{
                        (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                        returnFlight?.fare[0]?.commercialData?.finalAmount+
                        (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                        departureFlight?.fare[0]?.commercialData?.finalAmount+
                        (passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         thirdFlight?.fare[0]?.commercialData?.finalAmount+
                         (passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         fourthFlight?.fare[0]?.commercialData?.finalAmount
                       }}
                      
                      
                    </span> -->
                     &nbsp;&nbsp;
                     <span *ngIf="tripEnable===false" class="pt-4">
                      <button *ngIf="!showSpiner"   mat-raised-button color="accent"   (click)="openReturnWindow()">
                      Book
                    </button>   
                    <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;" disabled  >Book</button>
    
                    </span>
                    <span *ngIf="tripEnable===true" class="pt-4">
                      <button *ngIf="!showSpiner"   mat-raised-button color="accent"   (click)="openReturnWindow()">
                      Select Flight
                    </button>   
                    <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;" disabled  > Select Flight</button>
    
                    </span>

    
    
            </mat-expansion-panel-header>
            <mat-expansion-panel-header class="col-md-12">
          <div *ngIf="departureFlight" class="col-md-12 row pt-3">
            <div class="col-md-6 d-flex justify-content-start bold" style="color:rgb(1,123,254);" (click)="openReturnPopup(true,true,true,true);onClickITINERARYTab()">
              Flight Details
          </div>
          
          </div>
          </mat-expansion-panel-header>
            </mat-expansion-panel> 


            </div>
</div>
</div>
<!--###################################  pendingFlight.gif ##################################################
     ################################### pendingFlight.gif  ################################################## 
      ################################### pendingFlight.gif ##################################################-->
      <div *ngIf="!showPending&&blankList" class=" no-result-container " style="padding: 1.3rem;text-align: center;background-color: antiquewhite;">
        <div class="icon">
          <!-- Use an SVG or FontAwesome icon for the magnifying glass -->
          <!-- <img src="assets/images/" alt="No Result Icon"> -->
        </div>
        <h2>No Result Found</h2>
        <p>Sorry, there are no matching results</p>
      </div>
      <div *ngIf="showPending" >
  <div class="gif-container">
    <img src="../../../assets/images/pendingFlight.gif" >
</div>
</div>


<!--###################################  flightDetails ##################################################
     ################################### flightDetails  ################################################## 
      ################################### flightDetails ##################################################-->

<div class="modal" id="myMod" [style.display]="!flightDetails ? 'block' : 'none'" >
  <div class="modal-dialog" >
      <div class="modal-content " >
          <div class="modal-header title">
            <h4 class="modal-title">Flight Details</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
            </div>
            <div class="modal-body"  *ngIf="returnflight">
              <div class="mb-3 mt-1">
                <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( returnflight[0]?.fromAirport)}} to {{cityFilter(returnflight[0]?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>
            </div>
              <mat-tab-group #tabGroup  mat-stretch-tabs="false" mat-align-tabs="start" style="overflow: auto; max-height: 50vh;">
                <mat-tab  label="ITINERARY"  >  
                        <!--##################### ITINERARY tab-1 #############################-->
                        <!--##################### ITINERARY tab-1 #############################-->
                        <!--##################### ITINERARY tab-1 #############################-->
                        <!--##################### ITINERARY tab-1 #############################-->
<span *ngIf="onewayBoolean">
    <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of departureFlight.flightDetailsList" >
      
      <div class="mb-3 mt-1">
        <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
    </div><br>
  <div class="col-md-2">
    <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">

  
<br>
{{fligthNameFilter(element?.carrierName)}}<br>
    <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
      <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
      <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
     <!--<span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
    -->
    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
      <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>

    </span>
</div>

<div class="col-md-2">
    {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
    <br>
    <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
</div>
<div class="col-md-2">
    <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
    <br>
    <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
   
</div>
<div class="col-md-2">
  {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
    <br>
    <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
</div>
<div class="col-md-2">
        
    <!-- <span style="font-size: 12px;">Check-in baggage</span>
    <br>
    <span style="font-size: 12px;">  Cabin baggage</span> -->
</div>
<div class="col-md-2">
    <!-- <span style="font-size: 13px;">20kg/ Adult</span>
     <br>
     <span style="font-size: 13px;">7kg/ Adult</span> -->
 </div>
    </div>
</span>
    
    <!--##################### ITINERARY tab-2 #############################-->
    <!--##################### ITINERARY tab-2 #############################-->
    <!--##################### ITINERARY tab-2 #############################-->
    <!--##################### ITINERARY tab-2 #############################-->

<span *ngIf="returnFlight&&returnBoolean" >
  <div *ngIf="onewayBoolean&&returnBoolean" class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
    <span class="panel-swap  " ><mat-icon>swap_vert</mat-icon></span></div>
    <div class="col-md-12 mt-2 row " *ngFor="let element of returnFlight.flightDetailsList">
      <div class="mb-3 mt-1">
        <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
    </div><br>
  <div class="col-md-2">
    <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">

  
<br>
    {{fligthNameFilter(element?.carrierName)}}<br>
    <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
      <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" alt="external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2"/>
      <span style="padding-left: 4px;">{{element?.equipmentType}}</span>
      <br>
   
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
      <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"><mat-icon style="font-size: large;">location_on</mat-icon> {{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>

    </span>
</div>

<div class="col-md-2">
    {{returnFlight?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
    <br>
    <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
</div>
<div class="col-md-2">
    <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
    <br>
    <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
   
</div>
<div class="col-md-2">
  {{returnFlight.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
    <br>
    <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
</div>
<div class="col-md-2">
        
    <!-- <span style="font-size: 12px;">Check-in baggage</span>
    <br>
    <span style="font-size: 12px;">  Cabin baggage</span> -->
</div>
<div class="col-md-2">
    <!-- <span style="font-size: 13px;">20kg/ Adult</span>
     <br>
     <span style="font-size: 13px;">7kg/ Adult</span> -->
 </div>
    </div>
  </span>

 <!--##################### ITINERARY tab-3 #############################-->
    <!--##################### ITINERARY tab-3 #############################-->
    <!--##################### ITINERARY tab-3 #############################-->
    <!--##################### ITINERARY tab-3 #############################-->

    <span *ngIf="thirdFlight&&thirdBoolean" >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>
          <div class="col-md-12 mt-2 row " *ngFor="let element of thirdFlight.flightDetailsList">
            <div class="mb-3 mt-1">
              <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
          </div><br>
        <div class="col-md-2">
          <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
      
        
      <br>
          {{fligthNameFilter(element?.carrierName)}}<br>
          <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
            <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" alt="external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2"/>
            <span style="padding-left: 4px;">{{element?.equipmentType}}</span>
            <br>
         
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
            <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"><mat-icon style="font-size: large;">location_on</mat-icon> {{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
      
          </span>
      </div>
      
      <div class="col-md-2">
          {{thirdFlight?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
          <br>
          <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
          <br>
          <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
      </div>
      <div class="col-md-2">
          <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
          <br>
          <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
         
      </div>
      <div class="col-md-2">
        {{thirdFlight.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
          <br>
          <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
          <br>
          <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
      </div>
      <div class="col-md-2">
              
          <!-- <span style="font-size: 12px;">Check-in baggage</span>
          <br>
          <span style="font-size: 12px;">  Cabin baggage</span> -->
      </div>
      <div class="col-md-2">
          <!-- <span style="font-size: 13px;">20kg/ Adult</span>
           <br>
           <span style="font-size: 13px;">7kg/ Adult</span> -->
       </div>
          </div>
        </span>



        <!--##################### ITINERARY tab-4 #############################-->
    <!--##################### ITINERARY tab-4 #############################-->
    <!--##################### ITINERARY tab-4 #############################-->
    <!--##################### ITINERARY tab-4 #############################-->

    <span *ngIf="fourthFlight&&fourthBoolean" >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>
          <div class="col-md-12 mt-2 row " *ngFor="let element of fourthFlight.flightDetailsList">
            <div class="mb-3 mt-1">
              <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
          </div><br>
        <div class="col-md-2">
          <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
      
        
      <br>
          {{fligthNameFilter(element?.carrierName)}}<br>
          <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
            <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" alt="external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2"/>
            <span style="padding-left: 4px;">{{element?.equipmentType}}</span>
            <br>
         
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
            <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"><mat-icon style="font-size: large;">location_on</mat-icon> {{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
      
          </span>
      </div>
      
      <div class="col-md-2">
          {{fourthFlight?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
          <br>
          <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
          <br>
          <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
      </div>
      <div class="col-md-2">
          <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
          <br>
          <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
         
      </div>
      <div class="col-md-2">
        {{fourthFlight.toAirport}}&nbsp;{{element.schArrivalTime | date:'hh:mm a'}}
          <br>
          <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
          <br>
          <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
      </div>
      <div class="col-md-2">
              
          <!-- <span style="font-size: 12px;">Check-in baggage</span>
          <br>
          <span style="font-size: 12px;">  Cabin baggage</span> -->
      </div>
      <div class="col-md-2">
          <!-- <span style="font-size: 13px;">20kg/ Adult</span>
           <br>
           <span style="font-size: 13px;">7kg/ Adult</span> -->
       </div>
          </div>
        </span>
    </mat-tab>
    <mat-tab  label="FARE" >


          <!--##################### FARE tab-1 #############################-->
    <!--##################### FARE tab-1 #############################-->
    <!--##################### FARE tab-1 #############################-->
    <!--##################### FARE tab-1 #############################-->
      <span *ngIf="departureFlight&&onewayBoolean" class="col-md-12 mt-2 mb-2 row">

      
      <div class="col-md-5 ">

      <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                style="overflow-y:scroll;max-height: 95%; width: 100%;">
                <thead class="thead-light" >
                  <tr>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                    <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>



                  </tr>
                </thead>
                <tbody >
                  <tr  style="height: 25px; ">
                    <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                      {{(passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)}}</td>
                   
                    <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                      {{(passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)}}</td> -->
                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.baseFare}}</td>
                         
                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.finalTax}}</td>


                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.commercialData?.Fee?.value}}</td>
                  
                  
                  
                  </tr>
                </tbody>
              </table>
              <div class=" mt-1" *ngIf="messageData.adultCount">
                <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                 <span> {{passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis?((passengerTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis):''}}


                  (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareTypeMapping(departureFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>)
                </span>
                
             
            </div>
            <div class=" mt-1" *ngIf="messageData.childCount">
              <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
              <span> {{passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis?((passengerCTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis):''}}


                (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareTypeMapping(departureFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                  {{ entry.key }}{{ entry.value | json }},
                 </span>)
              </span>
              
           
          </div>
          <div class=" mt-1" *ngIf="messageData.infantCount">
            <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
            <span> {{passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis?((passengerITypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis):''}}


              (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareTypeMapping(departureFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                {{ entry.key }}{{ entry.value | json }},
               </span>)
            </span>
            
         
        </div>
            </div>
            <div  class="col-md-7" >
              <mat-progress-bar *ngIf="farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

              <div style="height:40vh; overflow: auto;"  *ngIf="json">
             <div  *ngFor="let item of json" >
              <div class="col-md-12 title bold" style="text-align: center; padding: 4px; font-size: 14px;">{{ item.key }}</div>
              
              <div class="col-md-12"><pre [innerHTML]="item.value">{{ item.value}} </pre></div>

              </div>
            </div>
            </div>
          </span>
             <!--##################### FARE tab-2 #############################-->
    <!--##################### FARE tab-2 #############################-->
    <!--##################### FARE tab-2 #############################-->
    <!--##################### FARE tab-2 #############################-->
         <span *ngIf="returnFlight && returnBoolean" class="row col-md-12 mt-2 mb-2"  >
          <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
            <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

          <div class="col-md-5">


            <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                      style="overflow-y:scroll;max-height: 95%; width: 100%;">
                      <thead class="thead-light" >
                        <tr>
                          <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                          <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                          <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                          <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
      
      
      
                        </tr>
                      </thead>
                      <tbody >
                        <tr  style="height: 25px; ">
                          <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                            {{(passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                              (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                              (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)}}</td>
                         
                          <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                            {{(passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                            (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                            (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)}}</td>
       -->
       <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.baseFare}}</td>
                         
       <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.finalTax}}</td>
      
                          <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.commercialData?.Fee?.value}}</td>
                                  
                                  
                        </tr>
                      </tbody>
                    </table>
                    
                  <div class=" mt-1" *ngIf="messageData.adultCount">
                    <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                     <span> {{passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis?((passengerTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis):''}}
    
    
                      (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareTypeMapping(returnFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                        {{ entry.key }}{{ entry.value | json }},
                       </span>)
                    </span>
                    
                 
                </div>
                <div class=" mt-1" *ngIf="messageData.childCount">
                  <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                  <span> {{passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis?((passengerCTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis):''}}
    
    
                    (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareTypeMapping(returnFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                      {{ entry.key }}{{ entry.value | json }},
                     </span>)
                  </span>
                  
               
              </div>
              <div class=" mt-1" *ngIf="messageData.infantCount">
                <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                <span> {{passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis?((passengerITypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis):''}}
    
    
                  (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareTypeMapping(returnFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>)
                </span>
                
             
            </div>
                  </div>
                  <div class="col-md-7" >
                    <mat-progress-bar *ngIf="fareRjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

                    <div *ngIf="rJson" style="height:40vh; overflow: auto;">
                    <div  *ngFor="let item of rJson" >
                      <div class="col-md-12 title bold" style="text-align: center; padding: 4px; font-size: 14px;">{{ item.key }}</div>
                      
                      <div class="col-md-12"><pre [innerHTML]="item.value">{{ item.value}}</pre></div>
        
                      </div>
                    </div>
                  </div>
          </span>



  <!--##################### FARE tab-3 #############################-->
    <!--##################### FARE tab-3 #############################-->
    <!--##################### FARE tab-3 #############################-->
    <!--##################### FARE tab-3 #############################-->
    <span *ngIf="thirdFlight && thirdBoolean" class="row col-md-12 mt-2 mb-2"  >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

        <div class="col-md-5">


          <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                    style="overflow-y:scroll;max-height: 95%; width: 100%;">
                    <thead class="thead-light" >
                      <tr>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                        <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
    
    
    
                      </tr>
                    </thead>
                    <tbody >
                      <tr  style="height: 25px; ">
                        <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                          {{(passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                            (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                            (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)}}</td>
                       
                        <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                          {{(passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)}}</td>
     -->
     <td class="small  mb-0 mt-0 pl-0 pb-0" >{{thirdFlight?.fare[0]?.baseFare}}</td>
                         
     <td class="small  mb-0 mt-0 pl-0 pb-0" >{{thirdFlight?.fare[0]?.finalTax}}</td>
    
                        <td class="small  mb-0 mt-0 pl-0 pb-0" >{{thirdFlight?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{thirdFlight?.fare[0]?.commercialData?.Fee?.value}}</td>
                                
                                
                      </tr>
                    </tbody>
                  </table>
                  
                <div class=" mt-1" *ngIf="messageData.adultCount">
                  <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                   <span> {{passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareTypeMapping(thirdFlight)))[0]?.fareBasis?((passengerTypeMapping(fareTypeMapping(thirdFlight)))[0]?.fareBasis):''}}
  
  
                    (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareTypeMapping(thirdFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                      {{ entry.key }}{{ entry.value | json }},
                     </span>)
                  </span>
                  
               
              </div>
              <div class=" mt-1" *ngIf="messageData.childCount">
                <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                <span> {{passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareTypeMapping(thirdFlight)))[0]?.fareBasis?((passengerCTypeMapping(fareTypeMapping(thirdFlight)))[0]?.fareBasis):''}}
  
  
                  (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareTypeMapping(thirdFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>)
                </span>
                
             
            </div>
            <div class=" mt-1" *ngIf="messageData.infantCount">
              <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
              <span> {{passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareTypeMapping(thirdFlight)))[0]?.fareBasis?((passengerITypeMapping(fareTypeMapping(thirdFlight)))[0]?.fareBasis):''}}
  
  
                (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareTypeMapping(thirdFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                  {{ entry.key }}{{ entry.value | json }},
                 </span>)
              </span>
              
           
          </div>
                </div>
                <div class="col-md-7" >
                  <mat-progress-bar *ngIf="fareTjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

                  <div *ngIf="rJson" style="height:40vh; overflow: auto;">
                  <div  *ngFor="let item of tJson" >
                    <div class="col-md-12 title bold" style="text-align: center; padding: 4px; font-size: 14px;">{{ item.key }}</div>
                    
                    <div class="col-md-12"><pre [innerHTML]="item.value">{{ item.value}}</pre></div>
      
                    </div>
                  </div>
                </div>
        </span>



 <!--##################### FARE tab-4 #############################-->
    <!--##################### FARE tab-4 #############################-->
    <!--##################### FARE tab-4 #############################-->
    <!--##################### FARE tab-4 #############################-->
    <span *ngIf="fourthFlight && fourthBoolean" class="row col-md-12 mt-2 mb-2"  >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

        <div class="col-md-5">


          <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                    style="overflow-y:scroll;max-height: 95%; width: 100%;">
                    <thead class="thead-light" >
                      <tr>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                        <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
    
    
    
                      </tr>
                    </thead>
                    <tbody >
                      <tr  style="height: 25px; ">

                        <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                          {{(passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                            (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                            (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)}}</td>
                       
                        <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                          {{(passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                          (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)}}</td>
     -->
                         <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fourthFlight?.fare[0]?.baseFare}}</td>
                         
                          <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fourthFlight?.fare[0]?.finalTax}}</td>
                        <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fourthFlight?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fourthFlight?.fare[0]?.commercialData?.Fee?.value}}</td>
                                
                                
                      </tr>
                    </tbody>
                  </table>
                  
                <div class=" mt-1" *ngIf="messageData.adultCount">
                  <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                   <span> {{passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareTypeMapping(fourthFlight)))[0]?.fareBasis?((passengerTypeMapping(fareTypeMapping(fourthFlight)))[0]?.fareBasis):''}}
  
  
                    (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareTypeMapping(fourthFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                      {{ entry.key }}{{ entry.value | json }},
                     </span>)
                  </span>
                  
               
              </div>
              <div class=" mt-1" *ngIf="messageData.childCount">
                <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                <span> {{passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareTypeMapping(fourthFlight)))[0]?.fareBasis?((passengerCTypeMapping(fareTypeMapping(fourthFlight)))[0]?.fareBasis):''}}
  
  
                  (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareTypeMapping(fourthFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>)
                </span>
                
             
            </div>
            <div class=" mt-1" *ngIf="messageData.infantCount">
              <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
              <span> {{passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareTypeMapping(fourthFlight)))[0]?.fareBasis?((passengerITypeMapping(fareTypeMapping(fourthFlight)))[0]?.fareBasis):''}}
  
  
                (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareTypeMapping(fourthFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                  {{ entry.key }}{{ entry.value | json }},
                 </span>)
              </span>
              
           
          </div>
                </div>
                <div class="col-md-7" >
                  <mat-progress-bar *ngIf="fareFjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

                  <div *ngIf="rJson" style="height:40vh; overflow: auto;">
                  <div  *ngFor="let item of fJson" >
                    <div class="col-md-12 title bold" style="text-align: center; padding: 4px; font-size: 14px;">{{ item.key }}</div>
                    
                    <div class="col-md-12"><pre [innerHTML]="item.value">{{ item.value}}</pre></div>
      
                    </div>
                  </div>
                </div>
        </span>





      </mat-tab>
      <mat-tab  label="Cancellation"  >
        <!--##################### Cancellation tab-1 #############################-->
    <!--##################### Cancellation tab-1 #############################-->
    <!--##################### Cancellation tab-1 #############################-->
    <!--##################### Cancellation tab-1 #############################-->
        <div *ngIf="onewayBoolean" class="col-md-12 mt-2"  >
          <mat-progress-bar *ngIf="farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div style="height:40vh; overflow: auto;"  *ngIf="json && !departureFlight?.routeRequest?.localFareRules">
         <div  *ngFor="let item of json" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre >{{ item.value}} </pre></div>

          </div>
        </div>
        <div *ngIf="departureFlight?.routeRequest?.localFareRules">
          <!-- cancellationRuleTxt -->
          <!-- <pre> {{fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt}}</pre> -->


          <table class="styled-popup-tables ">
            <thead>
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
               
    
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.cancellationRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>

          






          
         </div>
        </div>

          <!--##################### Cancellation tab-2 #############################-->
    <!--##################### Cancellation tab-2 #############################-->
    <!--##################### Cancellation tab-2 #############################-->
    <!--##################### Cancellation tab-2 #############################-->
        <span *ngIf="returnFlight && returnBoolean" class="row col-md-12 mt-2 mb-2"  >
          <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
            <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

        <div class="col-md-12" >
          <mat-progress-bar *ngIf="fareRjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div *ngIf="rJson && !returnFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
          <div  *ngFor="let item of rJson" >
            <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
            
            <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre >{{ item.value}}</pre></div>

            </div>
          </div>
          <div *ngIf="returnFlight?.routeRequest?.localFareRules">
            <table class="styled-popup-tables ">
              <thead>
                <tr  >
                  <!-- Dynamic headers based on tableHeaders array -->
                  <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                  <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee  <small class="grey"> (Per passenger)</small></th>
                                   <!-- + Gilpin Fee -->

      
                </tr>
              </thead>
              <tbody class="grey">
                <!-- Iterate through dynamic data rows -->
                <tr   *ngFor="let schedule of convertjson(fareTypeMapping(returnFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                  <!-- Display structured data -->
                  
                 
                  <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                  
                  <td class="" style="padding: 8px;">
                    <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    
                    </td>
  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </span>


  <!--##################### Cancellation tab-3 #############################-->
    <!--##################### Cancellation tab-3 #############################-->
    <!--##################### Cancellation tab-3 #############################-->
    <!--##################### Cancellation tab-3 #############################-->
    <span *ngIf="thirdFlight && thirdBoolean" class="row col-md-12 mt-2 mb-2"  >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

      <div class="col-md-12" >
        <mat-progress-bar *ngIf="fareTjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

        <div *ngIf="tJson && !thirdFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
        <div  *ngFor="let item of tJson" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre >{{ item.value}}</pre></div>

          </div>
        </div>
        <div *ngIf="thirdFlight?.routeRequest?.localFareRules">
          <table class="styled-popup-tables ">
            <thead>
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
               
    
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(thirdFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </span>


<!--##################### Cancellation tab-4 #############################-->
    <!--##################### Cancellation tab-4 #############################-->
    <!--##################### Cancellation tab-4 #############################-->
    <!--##################### Cancellation tab-4 #############################-->
    <span *ngIf="fourthFlight && fourthBoolean" class="row col-md-12 mt-2 mb-2"  >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

      <div class="col-md-12" >
        <mat-progress-bar *ngIf="fareFjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

        <div *ngIf="fJson && !fourthFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
        <div  *ngFor="let item of fJson" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre >{{ item.value}}</pre></div>

          </div>
        </div>
        <div *ngIf="fourthFlight?.routeRequest?.localFareRules">
          <table class="styled-popup-tables ">
            <thead>
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
               
    
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(fourthFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </span>



      </mat-tab>


      <mat-tab  label="Date Change">

        <!--##################### Date Change tab-1 #############################-->
    <!--##################### Date Change tab-1 #############################-->
    <!--##################### Date Change tab-1 #############################-->
    <!--##################### Date Change tab-1 #############################-->
        <div  *ngIf="onewayBoolean" class="col-md-12 mt-2" >
          <mat-progress-bar *ngIf="farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div style="height:40vh; overflow: auto;"  *ngIf="json && !departureFlight?.routeRequest?.localFareRules">
         <div  *ngFor="let item of json" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre>{{ item.value}} </pre></div>

          </div>
        </div>
        <div *ngIf="departureFlight?.routeRequest?.localFareRules">
          <!-- cancellationRuleTxt -->
          <!-- <pre> {{fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt}}</pre> -->


          <table class="styled-popup-tables ">
            <thead>
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
               
    
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>

          






          
         </div>
        </div>
         <!--##################### Date Change tab-2 #############################-->
    <!--##################### Date Change tab-2 #############################-->
    <!--##################### Date Change tab-2 #############################-->
    <!--##################### Date Change tab-2 #############################-->
        <span *ngIf="returnFlight && returnBoolean" class="row col-md-12 mt-2 mb-2"  >
          <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
            <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

        <div class="col-md-12" >
          <mat-progress-bar *ngIf="fareRjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div *ngIf="rJson && !returnFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
          <div  *ngFor="let item of rJson" >
            <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
            
            <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre>{{ item.value}}</pre></div>

            </div>
          </div>
          <div *ngIf="returnFlight?.routeRequest?.localFareRules">

            <table class="styled-popup-tables">
              <thead >
                <tr  >
                  <!-- Dynamic headers based on tableHeaders array -->
                  <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                  <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
                 
      
                </tr>
              </thead>
              <tbody class="grey">
                <!-- Iterate through dynamic data rows -->
                <tr   *ngFor="let schedule of convertjson(fareTypeMapping(returnFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                  <!-- Display structured data -->
                  
                 
                  <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                  
                  <td class="" style="padding: 8px;">
                    <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    
                    </td>
  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </span>


  <!--##################### Date Change tab-3 #############################-->
    <!--##################### Date Change tab-3 #############################-->
    <!--##################### Date Change tab-3 #############################-->
    <!--##################### Date Change tab-3 #############################-->
    <span *ngIf="thirdFlight &&thirdBoolean" class="row col-md-12 mt-2 mb-2"  >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

      <div class="col-md-12" >
        <mat-progress-bar *ngIf="fareTjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

        <div *ngIf="tJson && !thirdFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
        <div  *ngFor="let item of tJson" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre>{{ item.value}}</pre></div>

          </div>
        </div>
        <div *ngIf="thirdFlight?.routeRequest?.localFareRules">

          <table class="styled-popup-tables">
            <thead >
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
               
    
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(thirdFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </span>


<!--##################### Date Change tab-4 #############################-->
    <!--##################### Date Change tab-4 #############################-->
    <!--##################### Date Change tab-4 #############################-->
    <!--##################### Date Change tab-4 #############################-->
    <span *ngIf="fourthFlight && fourthBoolean" class="row col-md-12 mt-2 mb-2"  >
        <div *ngIf="onewayBoolean&&returnBoolean" class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
          <span  class="panel-swap "><mat-icon>swap_vert</mat-icon></span></div>

      <div class="col-md-12" >
        <mat-progress-bar *ngIf="fareFjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

        <div *ngIf="fJson && !fourthFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
        <div  *ngFor="let item of tJson" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre>{{ item.value}}</pre></div>

          </div>
        </div>
        <div *ngIf="fourthFlight?.routeRequest?.localFareRules">

          <table class="styled-popup-tables">
            <thead >
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
               
    
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(fourthFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </span>


      </mat-tab>

    </mat-tab-group>
              <div class="modal-footer">
                <div class="form-group form-inline ">
                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                </div>   
                
                <span  style="font-size: 18px; font-weight: bold;color: rgb(33,33,33);">
                  ₹ {{(returnBoolean?(returnFlight?(returnFlight?.fare[0]?.baseFare+returnFlight?.fare[0]?.finalTax+returnFlight?.fare[0].commercialData?.finalAmount):0):0)+
                      (onewayBoolean?(departureFlight?(departureFlight?.fare[0]?.baseFare+departureFlight?.fare[0]?.finalTax+departureFlight.fare[0].commercialData?.finalAmount):0):0)+
                    (thirdBoolean?(thirdFlight?(thirdFlight?.fare[0]?.baseFare+thirdFlight?.fare[0]?.finalTax+thirdFlight.fare[0].commercialData?.finalAmount):0):0)+
                    (fourthBoolean?(fourthFlight?(fourthFlight?.fare[0]?.baseFare+fourthFlight?.fare[0]?.finalTax+fourthFlight?.fare[0]?.commercialData?.finalAmount):0):0)}}


                  <!-- ₹ {{
                    (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                    returnFlight?.fare[0]?.commercialData?.finalAmount+
                    (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                    departureFlight?.fare[0]?.commercialData?.finalAmount+
                    (passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(thirdFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     thirdFlight?.fare[0]?.commercialData?.finalAmount+
                     (passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                    (passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     (passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(fourthFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     fourthFlight?.fare[0]?.commercialData?.finalAmount
                   }}
                   -->
                  
                  
                </span>
              <span *ngIf="tripEnable===false&&onewayBoolean&&returnBoolean" >
                  <button *ngIf="!showSpiner" mat-raised-button color="accent" (click)="openReturnWindow()" >
                  Book
                </button>   
                <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book</button>

                </span> 
                <span *ngIf="tripEnable===true&&onewayBoolean&&returnBoolean" >
                  <button *ngIf="!showSpiner" mat-raised-button color="accent" (click)="openReturnWindow()" >
                  Select Flight
                </button>   
                <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Select Flight</button>

                </span> 
              </div>
            </div>
            </div>
    </div>
</div>


<!--###################################  Email  ##################################################
     ################################### Email  ################################################## 
      ################################### Email ##################################################-->
      <!-- <p-dialog 
      header="Search Results" 
      [modal]="true"
      [(visible)]="sharePopup" 
      [style]="{ width: '80rem',height:'40rem' }" 
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
      [maximizable]="true"> -->

    
      <div class="modal" id="myMod" [style.display]="sharePopup ? 'block' : 'none'" >
        <div class="modal-dialog" >
            <div class="modal-content " >
                <div  class="modal-header title sticky-tabsahre" >
                  
                  <h4 *ngIf="!viewData" class="modal-title">Email Search Results
                  </h4>
                  <button *ngIf="viewData" mat-flat-button  style="font-size: medium;color: white; background-color: rgb(1,123,254);" class="close" data-dismiss="modal" (click)="copyToClipboard()">Copy Text</button>

                  <!-- <button *ngIf="viewData" type="button" style="font-size: medium;" class="close" data-dismiss="modal" (click)="copyToClipboard()">Copy Text</button> -->

                  <h4 *ngIf="viewData" class="modal-title">Fare Quotations</h4>
                  <button *ngIf="!viewData" type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                  <button *ngIf="viewData" type="button" class="close" data-dismiss="modal" (click)="closeviewData()">&times;</button>

                  </div>
                  <!-- style="overflow: auto; max-height: 50vh;" -->
                  <div class="modal-body" >

                    <table *ngIf="!viewData" class="share-tables " >
                      <!-- <thead>
                        <tr  >
                          <th style="padding: 8px;  text-align: center;text-align: left;" ></th>
                          <th style="padding: 8px;  text-align: center;text-align: left;"></th>
                         
                        </tr>
                      </thead> -->
                      <tbody class="">
                        <tr   >
                          
                          <td class="tdTitle " style="padding: 4px; ">Add User</td>
                          <td class="" style="padding: 4px;" >
                            <div class="row">

                            <mat-form-field class="col-md-7 " appearance="outline"style="margin-bottom:-20px">
          
                              <mat-chip-grid #chipGrids aria-label="city Selection">
                              </mat-chip-grid>
                              <div class="input-with-icon col-md-12">
                              <input  #travellerInput [formControl]="traveller" 
                                [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                                (matChipInputTokenEnd)="addTo($event)"
                                />
                                <mat-icon>arrow_drop_down</mat-icon>
                              </div>
                
                              <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                                <mat-option value="" *ngIf="usersList?.length===0">{{'Traveller Not Found'}}</mat-option>
                                <mat-option  *ngFor="let item of filteredTo | async" [value]="item.username"  (click)="onfilterClick(item.username)">
                                  
                                  {{item.firstName?(item.firstName+';'):''}}{{item.username}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                         <div class=" col-md-5 d-flex justify-content-start pt-2" style=" border-left: 1px solid #d2e1f5;" >
                            <button mat-raised-button (click)="onClickTo()" style="margin-right: 8px; margin-left: 8px;"><mat-icon>add</mat-icon>Add-To</button>
                            <button  mat-raised-button  (click)="onClickCC()"><mat-icon>add</mat-icon>Add-CC</button>
                          </div>
                        </div>

                          </td>
                         

                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">To</td>
                          <td class=" " style="padding: 4px; ">
                            <textarea class="form-control"  [(ngModel)]="addTO" name="to"  cols="60" rows="1"></textarea>
                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">CC</td>
                          <td class=" " style="padding: 4px; ">
                            <textarea class="form-control " [(ngModel)]="addCC" name="cc"  cols="60" rows="1"></textarea>
                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Reply-To	</td>
                          <td class=" " style="padding: 4px; ">
                            <input class="form-control"  type="text"> 
                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Format	</td>
                          <td class=" " style="padding: 4px; " >
                            <!-- <button *ngIf="!SelectedView" mat-raised-button  (click)="onClickView()">View Text</button>
                            <button *ngIf="SelectedView" mat-raised-button  (click)="onSelectedkView()">View Text</button> -->
                            <button  *ngIf="!SelectedView" mat-raised-button [style]="viewText==='view'?('background-color:#43a8c4;color:white'):''"  (click)="onClickTitle('view')">View Text</button>
                            <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='view'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('view')">View Text</button>
                            <button *ngIf="!SelectedView" mat-raised-button [style]="viewText==='email'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('email')" >Email</button>
                            <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='email'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('email')" >Email</button>
                            <button *ngIf="!SelectedView" mat-raised-button [style]="viewText==='excel'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('excel')" >Excel Download</button>
                            <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='excel'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('excel')" >Excel Download</button>


                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Subject</td>
                          <td class=" " style="padding: 4px; " >
                            <input class="form-control "  name="subject" >



                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Greeting Message	</td>
                          <td class=" " style="padding: 4px; " >
                            <textarea class="form-control "  name="Message"  cols="60" rows="4"></textarea>



                          </td>
                        </tr>
                      </tbody>
                    </table>
                 <div *ngIf="fetchAllData && viewData"class="row" >
                    <!-- <div *ngFor="let option of returnflight; let optionIndex = index " >
                      <div *ngFor="let flight of option?.flights;let flightIndex = index" class="row">
                        <p>Option {{ flightIndex  + 1}}</p>
                          <div *ngFor="let fare of flight?.fare; let detailIndex = index" class="col-md-4">

                          
                          <p>{{ flight?.flightDetailsList[0]?.carrierName }} {{ flight?.flightDetailsList[0]?.flightNumber }} {{ option?.fromAirport }}{{ option?.toAirport }} {{ flight?.schDepartureTime | date: 'dd-MMM' }} {{ flight?.schDepartureTime | date: 'HHmm' }} {{ flight?.schArrivalTime | date: 'HHmm' }}</p>
                          <p>Ticket Cost: INR {{ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }}</p>
                          <p>Fare Type: {{ fare?.fareType }}</p>
                        </div>                   
                      </div>
                    </div>
                 -->
                 <!-- <textarea   class="form-control " [(ngModel)]="allEmailData" readonly name="area"  cols="100" rows="60"></textarea>


                 <textarea  class="form-control mt-2" readonly [(ngModel)]="allInboundEmailData" name="" id="" cols="100" rows="60"></textarea> -->

                <div  class="col-md-3">

                  <pre style="font-size: 11px;">{{allEmailData}}</pre>

                 </div>
                 <div *ngIf="messageData.journeyType==='return'"  class="col-md-3">

                   <pre style="font-size: 11px;">{{allInboundEmailData}}</pre>

                 </div>
                 <div *ngIf="messageData.journeyType==='multiCity'"  class="col-md-3">

                  <pre style="font-size: 11px;">{{allInboundEmailData}}</pre>

                </div>
                <div *ngIf="messageData.journeyType==='multiCity'"  class="col-md-3">

                  <pre style="font-size: 11px;">{{allInboundTEmailData}}</pre>

                </div>
                <div *ngIf="messageData.journeyType==='multiCity'"  class="col-md-3">

                  <pre style="font-size:11px">{{allInboundFEmailData}}</pre>

                </div>
                  </div>
                </div>
                <!-- <ng-template pTemplate="footer"> -->

                  <div class="modal-footer" *ngIf="!viewData">

                    <div class="form-group form-inline ">
                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                    </div>   
                      <!-- <button  class="btn btn-outline-success c-width-100px shadow " >Send</button> -->
                      <button *ngIf="!SelectedView&&viewText==='view'" class="btn btn-outline-success c-width-100px shadow " (click)="onClickView()">Send</button>
                      <button *ngIf="SelectedView&&viewText==='view'" class="btn btn-outline-success c-width-100px shadow " (click)="onSelectedkView()">Send</button>
                      <button *ngIf="!SelectedView&&viewText==='email'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow "  (click)="allRequest()">Send</button>
                      <button *ngIf="SelectedView&&viewText==='email'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow " (click)="selectedRequest()" >Send</button>
                      <button *ngIf="!SelectedView&&viewText==='excel'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow "  (click)="allRequestDownload()">Excel Download</button>
                      <button *ngIf="SelectedView&&viewText==='excel'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow " (click)="selectedRequestDownload()" >Excel Download</button>

                      <button type="button" class="btn btn-outline-primary c-width-100px shadow" style="margin-left: 8px;" data-dismiss="modal" (click)="closePopup()">Close</button>
                 
                  </div>
<!-- </ng-template> -->
                 
                <!-- </p-dialog> -->
          </div>
      </div>
    </div>
    <span    *ngIf="returnflight&&countdown<180"
    style="background-color: rgb(6, 141, 146);padding: 10px;border-radius: 4px;color: white; position: sticky;bottom:0 ;left:38%;z-index: 5;"  > 
    <span *ngIf="countdown!=0"  style="color: #fff;background-color: rgb(6, 141, 146);"> Search Session will Expire in  - {{convertSecondsToMinSec(countdown)}}</span>
    <span *ngIf="countdown===0" style="color: #fff;background-color: red;"> Search session has been expired  need to Re-Search</span>
  </span>
  <button *ngIf="returnflight"
  (click)="scroll(tops)" class="tabActives"  style="z-index: 2; position: sticky;bottom:0 ;left:100%"   mat-fab><mat-icon style="margin-left: 4px;">expand_less</mat-icon></button>
  
   